// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --brand: #6b1d1d;
  --brand-strong: #521313;
  --brand-soft: #f7ecec;
  --ink: #111827;
  --ink-2: #374151;
  --muted: #5b6472;
  --line: #d6dae1;
  --line-soft: #e8ebf0;
  --bg: #f4f5f7;
  --surface: #ffffff;
  --focus: #1d4ed8;

  --complete: #166534;
  --complete-bg: #dcfce7;
  --created: #1e40af;
  --created-bg: #dbeafe;
  --draft: #92400e;
  --draft-bg: #fef3c7;
  --missing: #991b1b;
  --missing-bg: #fee2e2;
  --new: #334155;
  --new-bg: #eef1f5;

  --radius: 10px;
  --radius-sm: 6px;
  --shadow: 0 1px 2px rgba(17, 24, 39, 0.06), 0 1px 3px rgba(17, 24, 39, 0.08);
  --shadow-lg: 0 12px 32px rgba(17, 24, 39, 0.18);
  --font: 'IBM Plex Sans Arabic', 'Noto Sans Arabic', 'Segoe UI', Tahoma, system-ui, sans-serif;
}

/* Dark mode: bridges this file's own token names to the already-dark-ready
   palette in styles/tokens/tokens.css (which shares the same .dark class),
   instead of hand-authoring a second full palette. */
.dark {
  --brand: var(--primary);
  --brand-strong: var(--primary-hover);
  --brand-soft: var(--primary-subtle);
  --ink: var(--foreground);
  --ink-2: var(--text-subtle);
  --muted: var(--muted-foreground);
  --line: var(--border);
  --line-soft: var(--border);
  --bg: var(--background);
  --surface: var(--card);

  --complete: var(--success);
  --complete-bg: var(--success-subtle);
  --created: var(--info);
  --created-bg: var(--info-subtle);
  --draft: var(--warning);
  --draft-bg: var(--warning-subtle);
  --missing: var(--danger);
  --missing-bg: var(--danger-subtle);
  --new: var(--muted-foreground);
  --new-bg: var(--secondary);

  --shadow: 0 1px 2px rgba(0, 0, 0, 0.4), 0 1px 3px rgba(0, 0, 0, 0.5);
  --shadow-lg: 0 12px 32px rgba(0, 0, 0, 0.6);
  color-scheme: dark;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

html {
  -webkit-text-size-adjust: 100%;
}

body {
  margin: 0;
  font-family: var(--font);
  font-size: 15px;
  line-height: 1.6;
  color: var(--ink);
  background: var(--bg);
}

h1,
h2,
h3,
p {
  margin: 0;
}

h1 {
  font-size: 1.5rem;
  font-weight: 700;
  line-height: 1.3;
}

a {
  color: var(--brand);
}

button,
input,
select,
textarea {
  font: inherit;
  color: inherit;
}

:focus-visible {
  outline: 3px solid var(--focus);
  outline-offset: 2px;
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

.skip-link {
  position: absolute;
  inset-inline-start: 1rem;
  top: -3rem;
  z-index: 100;
  padding: 0.5rem 1rem;
  background: var(--ink);
  color: #fff;
  border-radius: var(--radius-sm);
}

.skip-link:focus {
  top: 0.5rem;
}

.muted {
  color: var(--muted);
}

.small {
  font-size: 0.85rem;
}

.num {
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}

.ltr-cell {
  text-align: end;
}

.icon {
  flex-shrink: 0;
}

/* ---------- Layout ---------- */

.brand__mark {
  display: grid;
  place-items: center;
  width: 38px;
  height: 38px;
  border-radius: 9px;
  background: var(--surface);
  color: var(--brand);
  font-weight: 700;
  letter-spacing: 0.02em;
  direction: ltr;
}

.main {
  flex: 1 1;
  width: 100%;
  max-width: 1440px;
  margin: 0 auto;
  padding: clamp(1rem, 2.5vw, 1.75rem) clamp(0.75rem, 3vw, 2rem) 5rem;
}

.main:focus {
  outline: none;
}

.page {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.page__head {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem 1rem;
}

.toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.5rem;
}

/* ---------- Site detail header ---------- */

.site-head {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.5rem 1.5rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid var(--line-soft);
  margin-bottom: 1rem;
}

.site-head__title {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  flex-basis: 100%;
}

.site-head__title h1 {
  margin: 0;
}

.site-head__meta {
  display: flex;
  flex-wrap: wrap;
  gap: 0.25rem 1rem;
  color: var(--muted);
  font-size: 0.9rem;
}

.site-head__meta span {
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
}

.site-head__people {
  display: flex;
  flex-wrap: wrap;
  gap: 1.5rem;
}

.site-head__person {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.site-head__person-text {
  display: flex;
  flex-direction: column;
  line-height: 1.3;
}

.site-head__person strong {
  font-size: 0.88rem;
}

.site-head__person small {
  color: var(--muted);
  font-size: 0.78rem;
}

.site-head__edit {
  margin-inline-start: auto;
}

.stack {
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
}

/* ---------- Project header ---------- */

.project {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.project__head {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.crumbs {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  font-size: 0.95rem;
  flex-wrap: wrap;
}

.crumbs span[aria-current] {
  font-weight: 600;
}

.project__meta {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.4rem 1rem;
  color: var(--muted);
  font-size: 0.9rem;
}

.tabs {
  display: flex;
  gap: 0.25rem;
  overflow-x: auto;
  overflow-y: hidden;
  border-bottom: 1px solid var(--line);
  scrollbar-width: thin;
}

.tab {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.6rem 0.9rem;
  color: var(--ink-2);
  text-decoration: none;
  font-weight: 500;
  border-bottom: 3px solid transparent;
  margin-bottom: -1px;
  white-space: nowrap;
  min-height: 44px;
}

.tab:hover {
  color: var(--brand);
}

.tab.is-active {
  color: var(--brand);
  border-bottom-color: var(--brand);
  font-weight: 600;
}

.tab.is-disabled {
  color: var(--muted);
  cursor: default;
}

.chip {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  padding: 0.05rem 0.55rem;
  border-radius: 999px;
  background: var(--new-bg);
  color: var(--ink-2);
  font-size: 0.8rem;
  font-weight: 500;
  white-space: nowrap;
}

.chip--today {
  margin-inline-start: 0.4rem;
  background: var(--brand);
  color: #fff;
}

.chip--info {
  background: var(--created-bg);
  color: var(--created);
}

.chip--warning {
  background: var(--draft-bg);
  color: var(--draft);
}

.weather-row {
  display: grid;
  grid-template-columns: repeat(7, minmax(0, 1fr));
  gap: 0.6rem;
}

.weather-day {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.25rem;
  padding: 0.8rem 0.5rem;
  text-align: center;
  background: var(--surface-muted, var(--bg));
  border: 1px solid var(--line-soft);
  border-radius: var(--radius);
}

.weather-day--alert {
  background: var(--draft-bg);
  border-color: var(--draft);
}

.weather-day__alert {
  margin-top: 0.3rem;
  font-size: 0.75rem;
  font-weight: 600;
  color: var(--draft);
}

@media (max-width: 900px) {
  .weather-row {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
}

/* ---------- Buttons ---------- */

.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.45rem;
  min-height: 42px;
  padding: 0.45rem 1rem;
  border-radius: var(--radius-sm);
  border: 1px solid var(--line);
  background: var(--surface);
  color: var(--ink);
  font-weight: 600;
  text-decoration: none;
  cursor: pointer;
  white-space: nowrap;
  transition: background-color 150ms ease, border-color 150ms ease, color 150ms ease;
}

.btn:hover:not(:disabled) {
  background: #f3f4f6;
}

.btn:disabled {
  cursor: not-allowed;
  opacity: 0.55;
}

.btn--sm {
  min-height: 34px;
  padding: 0.25rem 0.7rem;
  font-size: 0.875rem;
}

.btn--block {
  width: 100%;
}

.btn--primary {
  background: var(--brand);
  border-color: var(--brand);
  color: #fff;
}

.btn--primary:hover:not(:disabled) {
  background: var(--brand-strong);
}

.btn--success {
  background: var(--complete);
  border-color: var(--complete);
  color: #fff;
}

.btn--success:hover:not(:disabled) {
  background: #14532d;
}

.btn--danger {
  background: var(--surface);
  border-color: #fca5a5;
  color: var(--missing);
}

.btn--danger:hover:not(:disabled) {
  background: var(--missing-bg);
}

.btn--ghost {
  background: transparent;
  border-color: transparent;
  color: var(--brand);
}

.btn--ghost:hover:not(:disabled) {
  background: var(--brand-soft);
}

.btn--required {
  border-color: var(--missing);
  color: var(--missing);
  border-style: dashed;
}

.icon-button {
  display: inline-grid;
  place-items: center;
  width: 38px;
  height: 38px;
  padding: 0;
  border: 1px solid transparent;
  border-radius: var(--radius-sm);
  background: transparent;
  color: var(--ink-2);
  cursor: pointer;
}

.icon-button:hover:not(:disabled) {
  background: #eef0f3;
  color: var(--ink);
}

.icon-button:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.rot-90 .icon {
  transform: rotate(90deg);
}

.link-button {
  border: 0;
  background: none;
  padding: 0.25rem;
  color: var(--brand);
  font-weight: 600;
  cursor: pointer;
  text-decoration: underline;
  text-underline-offset: 2px;
}

.link-button--danger {
  color: var(--missing);
}

/* ---------- Forms ---------- */

.field {
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
  min-width: 0;
}

.field__label {
  font-weight: 600;
  font-size: 0.9rem;
  color: var(--ink-2);
}

.field__required {
  color: var(--missing);
}

.field__hint {
  font-size: 0.82rem;
  color: var(--muted);
}

.field__error {
  font-size: 0.85rem;
  color: var(--missing);
  font-weight: 500;
}

.input {
  width: 100%;
  min-height: 42px;
  padding: 0.45rem 0.7rem;
  border: 1px solid var(--input, #b9bfc9);
  border-radius: var(--radius-sm);
  background: var(--surface);
  color: var(--ink);
}

.input:hover {
  border-color: var(--border-strong, #8b93a1);
}

.input:focus {
  border-color: var(--focus);
  outline: 2px solid rgba(29, 78, 216, 0.25);
  outline-offset: 0;
}

.input[aria-invalid='true'] {
  border-color: var(--missing);
}

.field__control {
  position: relative;
  display: flex;
}

.field__control .input {
  padding-inline-end: 2.5rem;
}

.field__adornment {
  position: absolute;
  inset-inline-end: 0.3rem;
  top: 50%;
  transform: translateY(-50%);
  display: inline-grid;
  place-items: center;
  width: 32px;
  height: 32px;
  border: 0;
  border-radius: var(--radius-sm);
  background: transparent;
  color: var(--muted);
  cursor: pointer;
}

.field__adornment:hover {
  background: #eef0f3;
}

.field__adornment--static {
  cursor: default;
}

.field__adornment--static:hover {
  background: transparent;
}

.input--area {
  min-height: 64px;
  resize: vertical;
  line-height: 1.5;
}

.input--compact {
  min-height: 36px;
  padding: 0.2rem 0.5rem;
  width: auto;
}

input[type='number'].input {
  direction: ltr;
  text-align: right;
}

input[type='date'].input {
  direction: ltr;
  text-align: right;
}

.checkbox {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  font-weight: 500;
}

.checkbox input,
td input[type='checkbox'] {
  width: 18px;
  height: 18px;
  accent-color: var(--brand);
}

.form-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.9rem 1rem;
}

.span-2 {
  grid-column: 1 / -1;
}

.location-map {
  display: flex;
  flex-direction: column;
  gap: 0.45rem;
}

.location-map__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
}

.location-map__frame {
  position: relative;
}

.location-map__canvas {
  height: 320px;
  border: 1px solid var(--line-soft);
  border-radius: var(--radius);
  overflow: hidden;
  background: #eef1f4;
}

.location-map__status {
  position: absolute;
  inset: 0;
  display: grid;
  place-items: center;
  color: var(--muted);
  font-size: 0.9rem;
  pointer-events: none;
}

.pac-container {
  z-index: 10000;
  font-family: inherit;
}

.form-actions {
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
  flex-wrap: wrap;
}

.inline-form {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 0.6rem;
  margin-top: 1rem;
}

.inline-form .field {
  flex: 1 1 200px;
}

.filters {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 0.75rem 1rem;
}

.filters .field {
  flex: 0 1 240px;
}

/* ---------- Cards ---------- */

.card {
  background: var(--surface);
  border: 1px solid var(--line-soft);
  border-radius: var(--radius);
  box-shadow: var(--shadow);
  position: relative;
  padding: 1rem 1.1rem;
  min-width: 0;
  scroll-margin-top: 120px;
}

.card__header {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem 1rem;
  margin-bottom: 0.85rem;
}

.card__title {
  font-size: 1.08rem;
  font-weight: 700;
  color: var(--ink);
}

.card__actions {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 0.5rem;
}

.subhead {
  margin: 1rem 0 0.5rem;
  font-size: 0.95rem;
  font-weight: 600;
  color: var(--ink-2);
}

/* ---------- Status ---------- */

.badge {
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  padding: 0.1rem 0.6rem;
  border-radius: 999px;
  font-size: 0.82rem;
  font-weight: 600;
  white-space: nowrap;
  border: 1px solid transparent;
}

.badge::before {
  content: '';
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: currentColor;
}

.badge--complete {
  background: var(--complete-bg);
  color: var(--complete);
}

.badge--created {
  background: var(--created-bg);
  color: var(--created);
}

.badge--draft {
  background: var(--draft-bg);
  color: var(--draft);
}

.badge--missing {
  background: var(--missing-bg);
  color: var(--missing);
}

.badge--new {
  background: var(--new-bg);
  color: var(--new);
  border-color: var(--line);
}

.badge--project-active {
  background: var(--complete-bg);
  color: var(--complete);
}

.badge--project-on_hold {
  background: var(--draft-bg);
  color: var(--draft);
}

.badge--project-completed {
  background: var(--created-bg);
  color: var(--created);
}

.stats {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(130px, 1fr));
  gap: 0.6rem;
}

.stat {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.1rem;
  padding: 0.75rem 0.9rem;
  border-radius: var(--radius);
  border: 1px solid var(--line-soft);
  border-inline-start: 4px solid var(--ink-2);
  background: var(--surface);
  box-shadow: var(--shadow);
  text-align: start;
  color: inherit;
  text-decoration: none;
}

button.stat,
a.stat {
  cursor: pointer;
  transition: border-color 150ms ease, box-shadow 150ms ease;
}

button.stat:hover,
a.stat:hover {
  box-shadow: 0 0 0 1px var(--line);
}

button.stat.is-active {
  box-shadow: 0 0 0 2px var(--ink);
}

.stat__value {
  font-size: 1.6rem;
  font-weight: 700;
  line-height: 1.2;
  font-variant-numeric: tabular-nums;
}

.stat__label {
  font-size: 0.88rem;
  color: var(--ink-2);
  font-weight: 500;
}

.stat--complete {
  border-inline-start-color: var(--complete);
}

.stat--created {
  border-inline-start-color: var(--created);
}

.stat--draft {
  border-inline-start-color: #d97706;
}

.stat--missing {
  border-inline-start-color: var(--missing);
}

.stat--new {
  border-inline-start-color: #94a3b8;
}

.stats--static .stat {
  border-inline-start-color: var(--brand);
}

.progress {
  flex: 1 1;
  height: 8px;
  min-width: 60px;
  border-radius: 999px;
  background: var(--line-soft);
  overflow: hidden;
}

.progress span {
  display: block;
  height: 100%;
  background: var(--brand);
  border-radius: inherit;
}

.progress--good span {
  background: var(--complete);
}

.progress--warn span {
  background: var(--draft);
}

.progress--danger span {
  background: var(--missing);
}

.avatar-stack {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.avatar-stack__item {
  width: 26px;
  height: 26px;
  font-size: 0.72rem;
  margin-inline-start: -8px;
  border: 2px solid var(--surface);
}

.avatar-stack__item:first-child {
  margin-inline-start: 0;
}

.avatar-stack__more {
  margin-inline-start: 0.35rem;
  font-size: 0.78rem;
  color: var(--muted);
}

.fill {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  min-width: 120px;
}

/* ---------- Ring / plan-bar (Sites cards) ---------- */

.ring__label {
  font-size: 0.95rem;
  font-weight: 700;
  fill: var(--ink);
}

.plan-bar {
  position: relative;
  height: 8px;
  border-radius: 999px;
  background: var(--line-soft);
  overflow: visible;
}

.plan-bar__fill {
  position: absolute;
  inset-inline-start: 0;
  top: 0;
  height: 100%;
  background: var(--brand);
  border-radius: 999px;
}

.plan-bar__tick {
  position: absolute;
  top: -3px;
  width: 2px;
  height: 14px;
  background: var(--ink);
  transform: translateX(-1px);
}

.legend {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  font-size: 0.82rem;
  color: var(--muted);
}

.legend__item {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
}

.legend__dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: var(--brand);
  flex-shrink: 0;
}

.legend__dot--planned {
  background: var(--ink);
}

.divider {
  height: 1px;
  background: var(--line-soft);
  border: none;
  margin: 0;
}

.site-card__head {
  display: flex;
  align-items: center;
  gap: 0.9rem;
}

.site-card__plan {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  min-width: 0;
}

.site-card__plan-head {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 0.5rem;
  font-weight: 600;
}

.plan-ahead {
  color: var(--complete);
  font-weight: 600;
}

.plan-behind {
  color: var(--draft);
  font-weight: 600;
}

.plan-onplan {
  color: var(--muted);
  font-weight: 600;
}

.site-card__last {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  font-size: 0.85rem;
}

.site-card__prep {
  display: flex;
  align-items: center;
  gap: 0.6rem;
}

.site-card__prep .shell__avatar {
  width: 32px;
  height: 32px;
  font-size: 0.85rem;
}

.site-card__prep-name {
  display: flex;
  flex-direction: column;
  line-height: 1.3;
}

.site-card__prep-name strong {
  font-size: 0.88rem;
}

.site-card__prep-name small {
  color: var(--muted);
  font-size: 0.78rem;
}

.status-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem 1.5rem;
}

.status-list li {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.today-icon {
  display: grid;
  place-items: center;
  flex-shrink: 0;
  width: 32px;
  height: 32px;
  border-radius: var(--radius-sm);
  background: var(--secondary, #f3f4f6);
  color: var(--ink-2);
}

.today-recent {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
}

.today-recent__row {
  display: flex;
  align-items: center;
  gap: 0.65rem;
  padding: 0.55rem 0;
  border-bottom: 1px solid var(--line-soft);
}

.today-recent__row:last-child {
  border-bottom: none;
}

.today-recent__body {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
}

.today-recent__body .code-link {
  font-weight: 700;
}

/* ---------- "Continue today's report" card ---------- */

.today-continue__head {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.today-continue__text {
  display: flex;
  flex-direction: column;
  gap: 0.1rem;
}

.today-continue__heading {
  font-weight: 700;
  color: var(--ink);
}

.today-continue__progress-label {
  margin: 0.85rem 0 0.4rem;
  font-size: 0.9rem;
  font-weight: 600;
  color: var(--ink-2);
}

.today-continue__footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 0.75rem;
  margin-top: 0.85rem;
}

/* ---------- "Today's tasks" card ---------- */

.today-tasks {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
}

.today-tasks__row {
  display: flex;
  align-items: flex-start;
  gap: 0.65rem;
  padding: 0.55rem 0;
  border-bottom: 1px solid var(--line-soft);
}

.today-tasks__row:last-child {
  border-bottom: none;
}

.today-tasks__status {
  display: grid;
  place-items: center;
  flex-shrink: 0;
  width: 20px;
  height: 20px;
  margin-top: 0.15rem;
  border-radius: 50%;
  border: 2px solid var(--line);
  color: transparent;
}

.today-tasks__row.is-done .today-tasks__status {
  background: var(--complete);
  border-color: var(--complete);
  color: #fff;
}

.today-tasks__body {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
}

.today-tasks__title {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  font-weight: 600;
  color: var(--ink);
  text-decoration: none;
}

.today-tasks__title:hover {
  text-decoration: underline;
}

.today-tasks__row.is-done .today-tasks__title {
  color: var(--ink-2);
  text-decoration: line-through;
}

/* ---------- Month switch / search / segmented ---------- */

.month-switch {
  display: flex;
  align-items: center;
  gap: 0.25rem;
  background: var(--surface);
  border: 1px solid var(--line);
  border-radius: var(--radius);
  padding: 0.2rem;
}

.month-switch__select {
  border: 0;
  background: transparent;
  font-size: 1.2rem;
  font-weight: 700;
  padding: 0.25rem 0.5rem;
  min-height: 40px;
  cursor: pointer;
}

.search {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0 0.6rem;
  border: 1px solid #b9bfc9;
  border-radius: var(--radius-sm);
  background: var(--surface);
  color: var(--muted);
  min-height: 40px;
}

.search:focus-within {
  border-color: var(--focus);
  outline: 2px solid rgba(29, 78, 216, 0.25);
}

.search input {
  border: 0;
  outline: none;
  background: transparent;
  min-width: 190px;
  color: var(--ink);
}

.segmented {
  display: inline-flex;
  padding: 3px;
  border-radius: var(--radius-sm);
  background: var(--line-soft);
  gap: 2px;
  flex-wrap: wrap;
}

.segmented button {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  border: 0;
  background: transparent;
  padding: 0.35rem 0.8rem;
  border-radius: 5px;
  font-weight: 600;
  color: var(--ink-2);
  cursor: pointer;
  min-height: 36px;
}

.segmented button[aria-pressed='true'],
.segmented button[aria-selected='true'] {
  background: var(--surface);
  color: var(--brand);
  box-shadow: var(--shadow);
}

.tabs-list {
  display: flex;
  align-items: center;
  gap: 1.5rem;
  border-bottom: 1px solid var(--line);
}

.tabs-trigger {
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  height: 40px;
  padding: 0 0.25rem;
  background: transparent;
  border: 0;
  cursor: pointer;
  font-size: 0.85rem;
  font-weight: 500;
  color: var(--muted-foreground, #4b5563);
}

.tabs-trigger[aria-selected='true'] {
  color: var(--foreground, #111928);
}

.tabs-trigger[aria-selected='true']::after {
  content: '';
  position: absolute;
  inset-inline: 0;
  bottom: 0;
  height: 2px;
  background: var(--primary, #6b1d1d);
}

.tabs-trigger__count {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 20px;
  padding: 0 0.5rem;
  border-radius: var(--radius-full, 9999px);
  /* NOTE: --muted here means "muted text color" (#5b6472, set in this file's own :root above),
     not the tokens.css background meaning (#f3f4f6) — use --secondary instead to avoid the clash. */
  background: var(--secondary, #f3f4f6);
  color: var(--muted-foreground, #4b5563);
  font-size: 0.75rem;
  font-weight: 500;
}

.tabs-trigger[aria-selected='true'] .tabs-trigger__count {
  background: var(--primary-subtle, #f7ecec);
  color: var(--primary-text, #6b1d1d);
}

/* ---------- Tables ---------- */

.table-wrap {
  position: relative;
  overflow-x: auto;
  margin: 0 -1.1rem;
  padding: 0 1.1rem;
}

.table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.93rem;
}

.table th {
  text-align: start;
  font-weight: 600;
  color: var(--ink-2);
  background: var(--secondary, #f7f8fa);
  padding: 0.55rem 0.7rem;
  border-bottom: 1px solid var(--line);
  white-space: nowrap;
}

.table td {
  padding: 0.55rem 0.7rem;
  border-bottom: 1px solid var(--line-soft);
  vertical-align: middle;
}

.table tbody tr:hover {
  background: var(--secondary, #fafbfc);
}

.table tbody tr.is-selected,
.table tbody tr.is-selected:hover {
  background: var(--primary-subtle, #f7ecec);
}

.table tr.is-today {
  background: var(--brand-soft);
}

.table tr.is-inactive td {
  color: var(--muted);
}

.table--compact th,
.table--compact td,
[data-density='compact'] .table th,
[data-density='compact'] .table td {
  padding: 0.25rem 0.5rem;
}

[data-density='compact'] .card {
  padding: 0.7rem 0.85rem;
}

[data-density='compact'] .card__header {
  margin-bottom: 0.5rem;
}

.table-footer {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.75rem;
  padding-top: 0.85rem;
}

.table-footer .spacer {
  flex: 1 0;
  min-width: 1rem;
}

.table-footer__rows {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.85rem;
  color: var(--ink-2);
  font-weight: 500;
}

.table-footer__rows select {
  width: auto;
  min-height: 32px;
}

.table-footer__pagination {
  display: flex;
  align-items: center;
  gap: 0.35rem;
}

.dropdown {
  position: relative;
}

.dropdown summary {
  list-style: none;
}

.dropdown summary::-webkit-details-marker {
  display: none;
}

.dropdown[open] summary {
  box-shadow: 0 0 0 2px var(--ink);
}

.dropdown__panel {
  position: absolute;
  z-index: 20;
  top: calc(100% + 0.3rem);
  inset-inline-end: 0;
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  min-width: 180px;
  padding: 0.6rem;
  background: var(--surface);
  border: 1px solid var(--line);
  border-radius: var(--radius-sm);
  box-shadow: var(--shadow-lg);
}

.dropdown__item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.9rem;
  cursor: pointer;
}

.code-link {
  font-weight: 700;
  font-variant-numeric: tabular-nums;
  text-decoration: none;
  white-space: nowrap;
  direction: ltr;
  unicode-bidi: isolate;
}

.code-link:hover {
  text-decoration: underline;
}

.count {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
}

.row-actions {
  display: flex;
  gap: 0.15rem;
  justify-content: flex-end;
}

/* ---------- Calendar ---------- */

.calendar {
  display: flex;
  flex-direction: column;
  gap: 4px;
  overflow-x: auto;
}

.calendar__row {
  display: grid;
  grid-template-columns: repeat(7, minmax(76px, 1fr));
  gap: 4px;
}

.calendar__row--head div {
  text-align: center;
  font-weight: 600;
  font-size: 0.85rem;
  color: var(--ink-2);
  padding: 0.3rem 0;
}

.calendar__row--head .is-weekend {
  color: var(--brand);
}

.calendar__cellwrap {
  display: flex;
}

.calendar__cell {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.1rem;
  width: 100%;
  min-height: 88px;
  padding: 0.4rem 0.5rem;
  border-radius: var(--radius-sm);
  border: 1px solid var(--line);
  background: var(--surface);
  text-align: start;
}

button.calendar__cell {
  cursor: pointer;
  border-inline-start-width: 4px;
}

button.calendar__cell:hover {
  box-shadow: 0 0 0 2px var(--line);
}

.calendar__cell.is-blank {
  background: transparent;
  border-color: transparent;
}

.calendar__cell.is-out {
  background: #f1f2f4;
  color: var(--muted);
}

.calendar__cell.is-today {
  box-shadow: 0 0 0 2px var(--brand);
}

.calendar__day {
  font-weight: 700;
  font-size: 1.05rem;
  font-variant-numeric: tabular-nums;
}

.calendar__code {
  font-size: 0.8rem;
  font-weight: 600;
  direction: ltr;
}

.calendar__status {
  font-size: 0.78rem;
  font-weight: 600;
}

.calendar__attach {
  position: absolute;
  top: 0.4rem;
  inset-inline-end: 0.45rem;
  display: inline-flex;
  align-items: center;
  gap: 2px;
  font-size: 0.75rem;
  color: var(--ink-2);
}

.calendar__cell--complete {
  border-inline-start-color: var(--complete);
  background: #f3fbf5;
}

.calendar__cell--complete .calendar__status {
  color: var(--complete);
}

.calendar__cell--created {
  border-inline-start-color: var(--created);
  background: #f4f7fe;
}

.calendar__cell--created .calendar__status {
  color: var(--created);
}

.calendar__cell--draft {
  border-inline-start-color: #d97706;
  background: #fffbeb;
}

.calendar__cell--draft .calendar__status {
  color: var(--draft);
}

.calendar__cell--missing {
  border-inline-start-color: var(--missing);
  background: #fef5f5;
}

.calendar__cell--missing .calendar__status {
  color: var(--missing);
}

.calendar__cell--new {
  border-inline-start-color: #94a3b8;
}

.calendar__cell--new .calendar__status {
  color: var(--new);
}

.calendar__cell--portfolio {
  min-height: 112px;
  gap: 2px;
  border-inline-start-width: 1px;
}

.calendar__cell.is-selected {
  box-shadow: 0 0 0 2px var(--brand);
}

.calendar__project {
  display: flex;
  align-items: center;
  gap: 4px;
  max-width: 100%;
  font-size: 0.72rem;
  font-weight: 600;
  line-height: 1.2;
}

.calendar__project-name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.calendar__dot {
  width: 8px;
  height: 8px;
  border-radius: 999px;
  flex: none;
  background: var(--new);
}

.calendar__dot--complete { background: var(--complete); }
.calendar__dot--created { background: var(--created); }
.calendar__dot--draft { background: var(--draft); }
.calendar__dot--missing { background: var(--missing); }
.calendar__dot--new { background: var(--new); }

.calendar__more {
  font-size: 0.72rem;
  font-weight: 600;
  color: var(--muted);
}

.calendar-legend {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem 1rem;
  list-style: none;
  margin: 0 0 1rem;
  padding: 0;
  font-size: 0.8rem;
  font-weight: 600;
}

.calendar-legend li {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
}

.calendar-day {
  list-style: none;
  margin: 0;
  padding: 0;
}

.calendar-day a {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.7rem 0;
  border-bottom: 1px solid var(--line);
  color: inherit;
  text-decoration: none;
}

.calendar-day a:hover {
  color: var(--brand);
}

.calendar-day__project {
  font-weight: 600;
  margin-inline-end: auto;
}

/* ---------- Projects ---------- */

.project-grid {
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 1rem;
}

.project-card {
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
  height: 100%;
  padding: 1.1rem;
  background: var(--surface);
  border: 1px solid var(--line-soft);
  border-top: 4px solid var(--brand);
  border-radius: var(--radius);
  box-shadow: var(--shadow);
  color: var(--ink);
  text-decoration: none;
  transition: box-shadow 150ms ease;
}

.project-card:hover {
  box-shadow: var(--shadow-lg);
}

/* ---------- New project ---------- */

.stepper {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin: 0;
  padding: 0;
  list-style: none;
}

.stepper li {
  flex: 1 1 180px;
}

.stepper button {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  width: 100%;
  padding: 0.6rem 0.8rem;
  border: 1px solid var(--line);
  border-radius: var(--radius-sm);
  background: var(--surface);
  color: var(--muted);
  font: inherit;
  font-weight: 600;
  text-align: start;
}

.stepper li.is-done button {
  color: var(--ink);
  cursor: pointer;
}

.stepper li.is-done button:hover {
  border-color: var(--brand);
}

.stepper li.is-current button {
  border-color: var(--brand);
  background: var(--brand-soft);
  color: var(--brand);
}

.stepper__index {
  display: inline-grid;
  place-items: center;
  flex: none;
  width: 1.6rem;
  height: 1.6rem;
  border-radius: 999px;
  background: var(--line-soft);
  color: var(--ink-2);
  font-size: 0.85rem;
}

.stepper li.is-current .stepper__index,
.stepper li.is-done .stepper__index {
  background: var(--brand);
  color: #fff;
}

.team-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 1rem;
}

.team-card {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.team-card > .btn {
  align-self: flex-start;
}

.team-list {
  display: grid;
  gap: 0.4rem;
  margin: 0;
  padding: 0;
  list-style: none;
}

.team-list li {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  padding: 0.45rem 0.6rem;
  border: 1px solid var(--line-soft);
  border-radius: var(--radius-sm);
  background: var(--bg);
}

.team-list li div {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.team-list .ltr-cell {
  overflow: hidden;
  text-overflow: ellipsis;
}

.team-empty {
  padding: 0.6rem;
  border: 1px dashed var(--line);
  border-radius: var(--radius-sm);
  color: var(--muted);
  text-align: center;
}

.summary-list {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 0.75rem 1.25rem;
  margin: 0;
}

.summary-list dt {
  color: var(--muted);
  font-size: 0.88rem;
  font-weight: 500;
}

.summary-list dd {
  margin: 0;
  font-weight: 600;
}

.stats--wide {
  grid-template-columns: repeat(auto-fit, minmax(170px, 1fr));
}

.stat__value.code-link {
  font-size: 1.1rem;
}

.project-card__top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: var(--brand);
}

.project-card h2 {
  font-size: 1.05rem;
  line-height: 1.5;
}

.project-card dl,
.info-grid {
  display: grid;
  gap: 0.35rem;
  margin: 0;
}

.project-card dl div {
  display: flex;
  gap: 0.5rem;
  font-size: 0.9rem;
}

.project-card dt,
.info-grid dt {
  color: var(--muted);
  font-weight: 500;
}

.project-card dd,
.info-grid dd {
  margin: 0;
}

.info-grid {
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 0.9rem 1.25rem;
}

.info-grid dt {
  font-size: 0.85rem;
  margin-bottom: 0.15rem;
}

.info-grid dd {
  font-weight: 500;
}

/* ---------- Report editor ---------- */

.report__head {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  justify-content: space-between;
  gap: 0.75rem 1rem;
}

.report__title {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.report__nav {
  display: flex;
  gap: 0.25rem;
  margin-inline-start: -0.7rem;
}

.report__title .code {
  white-space: nowrap;
  direction: ltr;
  unicode-bidi: isolate;
  color: var(--brand);
}

.report__date {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.5rem;
  color: var(--ink-2);
  font-weight: 500;
}

.section-nav {
  position: sticky;
  top: 58px;
  z-index: 20;
  display: flex;
  gap: 0.35rem;
  overflow-x: auto;
  padding: 0.5rem 0;
  background: var(--bg);
  scrollbar-width: thin;
}

.section-nav a {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  padding: 0.3rem 0.75rem;
  border-radius: 999px;
  border: 1px solid var(--line);
  background: var(--surface);
  color: var(--ink-2);
  font-size: 0.87rem;
  font-weight: 500;
  text-decoration: none;
  white-space: nowrap;
  min-height: 34px;
}

.section-nav a:hover {
  border-color: var(--brand);
  color: var(--brand);
}

.section-nav a.is-filled {
  border-color: #86efac;
  background: var(--complete-bg);
  color: var(--complete);
}

.report__layout {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 320px;
  gap: 1rem;
  align-items: start;
}

.report__main {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  min-width: 0;
}

.report__aside {
  position: sticky;
  top: 112px;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.lines {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.5rem;
}

.lines__table {
  width: 100%;
  border-collapse: collapse;
}

.lines__table th {
  text-align: start;
  font-size: 0.85rem;
  font-weight: 600;
  color: var(--ink-2);
  padding: 0.3rem 0.4rem;
  border-bottom: 1px solid var(--line);
}

.lines__table td {
  padding: 0.35rem 0.4rem;
  border-bottom: 1px solid var(--line-soft);
  vertical-align: top;
}

.lines__table--fixed th[scope='row'] {
  font-weight: 600;
  font-size: 0.92rem;
  color: var(--ink);
  border-bottom: 1px solid var(--line-soft);
  vertical-align: middle;
  white-space: nowrap;
  width: 30%;
}

.lines__index {
  width: 2.2rem;
  color: var(--muted);
  text-align: center !important;
  vertical-align: middle !important;
}

.col--sm {
  width: 110px;
}

.col--lg {
  width: 45%;
}

.lines__value {
  display: block;
  padding: 0.3rem 0;
  white-space: pre-wrap;
}

.lines__files {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.35rem;
  min-width: 140px;
}

.lines__remove {
  width: 44px;
  vertical-align: middle !important;
}

.lines__empty {
  color: var(--muted);
  font-size: 0.92rem;
  padding: 0.3rem 0;
}

.lines__table tr.is-missing-file td {
  background: #fff8f8;
}

.chips {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  gap: 0.35rem;
}

.card > .chips {
  margin-top: 0.6rem;
}

.file-chip {
  display: inline-flex;
  align-items: center;
  border: 1px solid var(--line);
  border-radius: 999px;
  background: #f8f9fb;
  max-width: 240px;
}

.file-chip__open {
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  border: 0;
  background: transparent;
  padding: 0.2rem 0.6rem;
  font-size: 0.82rem;
  color: var(--ink);
  cursor: pointer;
  min-width: 0;
  min-height: 30px;
}

.file-chip__open span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.file-chip__open:hover {
  color: var(--brand);
  text-decoration: underline;
}

.file-chip__remove {
  width: 28px;
  height: 28px;
  margin-inline-end: 2px;
}

.gallery {
  list-style: none;
  margin: 0.75rem 0 0;
  padding: 0;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
  gap: 0.6rem;
}

.gallery li {
  position: relative;
}

.gallery__item {
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 0;
  border: 1px solid var(--line);
  border-radius: var(--radius-sm);
  background: var(--surface);
  overflow: hidden;
  cursor: pointer;
  text-align: start;
}

.gallery__item:hover {
  border-color: var(--brand);
}

.gallery__thumb,
.archive__thumb {
  display: grid;
  place-items: center;
  aspect-ratio: 4 / 3;
  background: #eef0f3;
  color: var(--muted);
  overflow: hidden;
}

.gallery__thumb img,
.archive__thumb img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.gallery__name {
  padding: 0.3rem 0.5rem;
  font-size: 0.8rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.gallery__remove {
  position: absolute;
  top: 4px;
  inset-inline-end: 4px;
  background: rgba(255, 255, 255, 0.92);
  width: 32px;
  height: 32px;
}

.preview {
  display: grid;
  place-items: center;
  min-height: 240px;
  background: #111;
  border-radius: var(--radius-sm);
  margin-bottom: 0.6rem;
}

.preview img {
  max-width: 100%;
  max-height: 70vh;
  object-fit: contain;
}

.notes {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.notes li {
  padding: 0.6rem 0.8rem;
  border-inline-start: 3px solid var(--brand);
  background: #fafafb;
  border-radius: var(--radius-sm);
}

.notes p {
  white-space: pre-wrap;
}

.notes footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.82rem;
  color: var(--muted);
  margin-top: 0.25rem;
}

.note-form {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.5rem;
  margin-top: 0.9rem;
}

.note-form .field {
  width: 100%;
}

.comment-groups {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.comment-group__head {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  font-size: 0.82rem;
  font-weight: 600;
  color: var(--ink-2);
  margin-bottom: 0.5rem;
}

.comment-thread {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
}

.comment-message {
  display: flex;
  align-items: flex-start;
  gap: 0.55rem;
  padding: 0.6rem 0.7rem;
  background: #fafafb;
  border: 1px solid var(--line-soft);
  border-radius: var(--radius-sm);
}

.comment-message__avatar {
  flex-shrink: 0;
  display: grid;
  place-items: center;
  width: 24px;
  height: 24px;
  border-radius: 999px;
  background: var(--brand-soft);
  color: var(--brand);
  font-size: 0.72rem;
  font-weight: 700;
}

.comment-message__body {
  flex: 1 1 auto;
  min-width: 0;
}

.comment-message__head {
  display: flex;
  align-items: baseline;
  gap: 0.4rem;
  font-size: 0.85rem;
}

.comment-message__head time {
  font-size: 0.76rem;
  color: var(--muted);
}

.comment-message p {
  margin: 0.15rem 0 0;
  font-size: 0.86rem;
  white-space: pre-wrap;
}

.checklist,
.audit,
.timeline {
  list-style: none;
  margin: 0;
  padding: 0;
}

.checklist li {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.3rem 0;
  font-size: 0.92rem;
}

.checklist .is-done {
  color: var(--complete);
}

.checklist .is-todo {
  color: var(--missing);
  font-weight: 500;
}

.timeline li {
  position: relative;
  display: flex;
  flex-direction: column;
  padding-inline-start: 1.3rem;
  padding-bottom: 0.8rem;
  border-inline-start: 2px solid var(--line);
  margin-inline-start: 0.4rem;
}

.timeline li:last-child {
  border-inline-start-color: transparent;
  padding-bottom: 0.2rem;
}

.timeline li::before {
  content: '';
  position: absolute;
  inset-inline-start: -7px;
  top: 0.35rem;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: var(--surface);
  border: 2px solid var(--line);
}

.timeline li.is-done::before {
  background: var(--complete);
  border-color: var(--complete);
}

.timeline strong {
  font-size: 0.92rem;
}

.timeline span,
.timeline small {
  font-size: 0.85rem;
  color: var(--ink-2);
}

.timeline small {
  color: var(--muted);
}

.audit {
  max-height: 360px;
  overflow-y: auto;
}

.audit li {
  display: flex;
  flex-direction: column;
  padding: 0.4rem 0;
  border-bottom: 1px solid var(--line-soft);
  font-size: 0.85rem;
}

.audit li:last-child {
  border-bottom: 0;
}

.audit span {
  color: var(--muted);
}

.audit q {
  color: var(--ink-2);
  font-style: italic;
}

.back-link {
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  font-weight: 600;
  text-decoration: none;
}

.savebar {
  position: fixed;
  bottom: 1rem;
  left: 50%;
  transform: translateX(-50%);
  z-index: 40;
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 0.5rem 0.6rem 0.5rem 0.6rem;
  padding-inline-start: 1.1rem;
  background: var(--ink);
  color: #fff;
  border-radius: 999px;
  box-shadow: var(--shadow-lg);
  font-weight: 500;
}

.savebar .btn--primary {
  border-radius: 999px;
}

.bulk-bar {
  position: fixed;
  bottom: 1rem;
  left: 50%;
  transform: translateX(-50%);
  z-index: 40;
  display: flex;
  align-items: center;
  gap: 0.25rem;
  padding: 0.5rem;
  background: var(--surface);
  border: 1px solid var(--line);
  border-radius: var(--radius);
  box-shadow: var(--shadow-lg);
}

.bulk-bar__count {
  padding: 0 0.5rem;
  font-size: 0.85rem;
  font-weight: 500;
  color: var(--ink);
  white-space: nowrap;
}

.bulk-bar__separator {
  width: 1px;
  height: 16px;
  background: var(--line);
  flex-shrink: 0;
}

.bulk-bar .btn {
  min-height: 32px;
  padding: 0.35rem 0.75rem;
  background: transparent;
  border-color: transparent;
  color: var(--ink);
  font-weight: 600;
  font-size: 0.875rem;
}

.bulk-bar .btn:hover:not(:disabled) {
  background: var(--bg);
  border-color: transparent;
}

/* ---------- Alerts ---------- */

.alert {
  display: flex;
  align-items: flex-start;
  gap: 0.6rem;
  padding: 0.75rem 1rem;
  border-radius: var(--radius-sm);
  border: 1px solid;
}

.alert p {
  white-space: pre-wrap;
  margin-top: 0.2rem;
}

.alert .icon {
  margin-top: 0.2rem;
}

.alert--error {
  background: var(--missing-bg);
  border-color: #fca5a5;
  color: var(--missing);
}

.alert--warning {
  background: var(--draft-bg);
  border-color: #fcd34d;
  color: #78350f;
}

.alert--info {
  background: var(--created-bg);
  border-color: #93c5fd;
  color: var(--created);
}

.alert--success {
  background: var(--complete-bg);
  border-color: #86efac;
  color: var(--complete);
}

/* ---------- Archive / summaries / settings ---------- */

.archive {
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
  gap: 0.6rem;
}

.archive__item {
  display: grid;
  grid-template-columns: 72px 1fr auto;
  align-items: center;
  gap: 0.7rem;
  width: 100%;
  padding: 0.45rem;
  border: 1px solid var(--line);
  border-radius: var(--radius-sm);
  background: var(--surface);
  text-align: start;
  cursor: pointer;
  color: var(--ink-2);
}

.archive__item:hover {
  border-color: var(--brand);
}

.archive__thumb {
  width: 72px;
  border-radius: 4px;
}

.archive__meta {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.archive__meta strong {
  color: var(--ink);
  font-size: 0.9rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.archive__meta small {
  color: var(--muted);
}

.archive__row {
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
}

.summary-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(420px, 1fr));
  gap: 1rem;
}

.roles-cell--yes {
  color: var(--complete);
}

.roles-cell--conditional {
  color: var(--draft);
}

.roles-cell--no {
  color: var(--muted);
}

.catalog {
  list-style: none;
  margin: 0.8rem 0 0;
  padding: 0;
}

.catalog li {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 0.4rem;
  padding: 0.3rem 0;
  border-bottom: 1px solid var(--line-soft);
}

.catalog__label {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  font-weight: 500;
}

.catalog__actions {
  display: inline-flex;
  align-items: center;
  gap: 0.1rem;
}

/* ---------- Feedback ---------- */

.spinner {
  display: inline-block;
  width: 26px;
  height: 26px;
  border: 3px solid var(--line);
  border-top-color: var(--brand);
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

.spinner--inline {
  width: 16px;
  height: 16px;
  border-width: 2px;
  border-color: currentColor;
  border-top-color: transparent;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.loading {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.7rem;
  padding: 3rem 1rem;
  color: var(--muted);
}

.empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.6rem;
  padding: 2.5rem 1rem;
  text-align: center;
  color: var(--muted);
}

.empty__title {
  font-weight: 600;
  color: var(--ink-2);
}

.empty--error {
  color: var(--missing);
}

.toasts {
  position: fixed;
  top: 70px;
  inset-inline-start: 50%;
  transform: translateX(50%);
  z-index: 60;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  width: min(480px, calc(100vw - 2rem));
}

.toast {
  display: flex;
  align-items: flex-start;
  gap: 0.6rem;
  padding: 0.7rem 0.6rem 0.7rem 0.9rem;
  border-radius: var(--radius-sm);
  background: var(--surface);
  border: 1px solid var(--line);
  border-inline-start: 4px solid var(--complete);
  box-shadow: var(--shadow-lg);
  animation: toast-in 180ms ease-out;
}

.toast .icon {
  margin-top: 0.2rem;
}

.toast--success .icon {
  color: var(--complete);
}

.toast--error {
  border-inline-start-color: var(--missing);
}

.toast--error .icon {
  color: var(--missing);
}

.toast--info {
  border-inline-start-color: var(--created);
}

.toast--info .icon {
  color: var(--created);
}

.toast__body {
  flex: 1 1;
}

.toast__body ul {
  margin: 0.3rem 0 0;
  padding-inline-start: 1.1rem;
  font-size: 0.88rem;
  color: var(--ink-2);
}

.toast .icon-button {
  width: 30px;
  height: 30px;
}

@keyframes toast-in {
  from {
    opacity: 0;
    transform: translateY(-6px);
  }
}

/* ---------- Bell ---------- */

.bell {
  position: relative;
}

.bell__count {
  position: absolute;
  top: 2px;
  inset-inline-end: 0;
  min-width: 19px;
  height: 19px;
  padding: 0 5px;
  border-radius: 999px;
  background: #fbbf24;
  color: #111;
  font-size: 0.72rem;
  font-weight: 700;
  line-height: 19px;
  text-align: center;
}

.bell__panel {
  position: absolute;
  top: calc(100% + 8px);
  inset-inline-end: 0;
  width: min(360px, calc(100vw - 1.5rem));
  max-height: 70vh;
  overflow-y: auto;
  background: var(--surface);
  color: var(--ink);
  border: 1px solid var(--line);
  border-radius: var(--radius);
  box-shadow: var(--shadow-lg);
}

.bell__panel header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.6rem 0.8rem;
  border-bottom: 1px solid var(--line-soft);
}

.bell__panel ul {
  list-style: none;
  margin: 0;
  padding: 0;
}

.bell__panel li button {
  display: flex;
  gap: 0.6rem;
  width: 100%;
  padding: 0.6rem 0.8rem;
  border: 0;
  border-bottom: 1px solid var(--line-soft);
  background: var(--surface);
  text-align: start;
  cursor: pointer;
  color: var(--ink-2);
}

.bell__panel li button:hover {
  background: var(--secondary, #f7f8fa);
}

.bell__panel li button.is-unread {
  background: #fff9f0;
  color: var(--ink);
}

.bell__panel li button .icon {
  color: var(--missing);
  margin-top: 0.2rem;
}

.bell__panel li span {
  display: flex;
  flex-direction: column;
}

.bell__panel small {
  color: var(--muted);
}

.bell__empty {
  padding: 1.5rem;
  text-align: center;
  color: var(--muted);
}

.bell__footer {
  padding: 0.5rem 0.8rem;
  text-align: center;
}

/* ---------- Modal ---------- */

.modal-backdrop {
  position: fixed;
  inset: 0;
  z-index: 50;
  display: grid;
  place-items: center;
  padding: 1rem;
  background: rgba(17, 24, 39, 0.5);
}

.modal {
  display: flex;
  flex-direction: column;
  width: min(520px, 100%);
  max-height: calc(100vh - 2rem);
  background: var(--surface);
  border-radius: var(--radius);
  box-shadow: var(--shadow-lg);
}

.modal:focus {
  outline: none;
}

.modal--wide {
  width: min(820px, 100%);
}

.modal__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding: 0.9rem 1.1rem;
  border-bottom: 1px solid var(--line-soft);
}

.modal__header h2 {
  font-size: 1.1rem;
}

.modal__body {
  padding: 1.1rem;
  overflow-y: auto;
}

.modal__footer {
  display: flex;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 0.5rem;
  padding: 0.8rem 1.1rem;
  border-top: 1px solid var(--line-soft);
}

.side-sheet-backdrop {
  position: fixed;
  inset: 0;
  z-index: 50;
  display: flex;
  justify-content: flex-end;
  background: rgba(17, 24, 39, 0.5);
}

.side-sheet {
  display: flex;
  flex-direction: column;
  width: min(420px, 100%);
  height: 100%;
  background: var(--surface);
  box-shadow: var(--shadow-lg);
  animation: side-sheet-in 180ms ease-out;
}

.side-sheet:focus {
  outline: none;
}

.side-sheet .modal__body {
  flex: 1 1;
}

@keyframes side-sheet-in {
  from {
    transform: translateX(var(--side-sheet-offset, 100%));
  }
  to {
    transform: translateX(0);
  }
}

[dir='rtl'] .side-sheet {
  --side-sheet-offset: -100%;
}

.system-page {
  min-height: 100vh;
  display: grid;
  place-items: center;
  padding: 1.5rem;
  background: var(--bg);
}

.system-page__card {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.6rem;
  max-width: 420px;
  padding: 2.5rem 2rem;
  text-align: center;
  background: var(--surface);
  border: 1px solid var(--line-soft);
  border-radius: var(--radius);
  box-shadow: var(--shadow);
}

.system-page__icon {
  display: grid;
  place-items: center;
  width: 56px;
  height: 56px;
  margin-top: 0.4rem;
  border-radius: 999px;
  background: var(--brand-soft);
  color: var(--brand);
}

.system-page__code {
  font-size: 0.85rem;
  font-weight: 700;
  letter-spacing: 0.05em;
  color: var(--muted);
}

.system-page__actions {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 0.6rem;
  margin-top: 0.4rem;
}

.system-page__footer {
  margin-top: 0.8rem;
  padding-top: 0.8rem;
  border-top: 1px solid var(--line-soft);
  width: 100%;
  font-size: 0.85rem;
  color: var(--muted);
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  gap: 0.4rem;
}

.alert-dialog__header {
  display: flex;
  gap: 1rem;
  align-items: flex-start;
  margin-bottom: 1.1rem;
}

.alert-dialog__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  border-radius: 999px;
}

.alert-dialog__icon--danger {
  background: var(--missing-bg, #fee2e2);
  color: var(--missing, #991b1b);
}

.alert-dialog__header-text h2 {
  font-size: 1.1rem;
  margin: 0 0 0.3rem;
}

.alert-dialog__sections {
  margin-bottom: 1.1rem;
  padding-bottom: 1.1rem;
  border-bottom: 1px solid var(--line-soft);
}

.alert-dialog__sections .field__label {
  margin-bottom: 0.15rem;
}

.alert-dialog__checkbox-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.5rem 1rem;
  margin-top: 0.6rem;
}

/* ---------- Responsive ---------- */

@media (max-width: 1100px) {
  .report__layout {
    grid-template-columns: minmax(0, 1fr);
  }

  .report__aside {
    position: static;
  }
}

@media (max-width: 720px) {
  body {
    font-size: 15px;
  }

  .shell__user-info {
    display: none;
  }

  .form-grid {
    grid-template-columns: minmax(0, 1fr);
  }

  .summary-grid {
    grid-template-columns: minmax(0, 1fr);
  }

  .search input {
    min-width: 0;
    width: 100%;
  }

  .card__actions {
    width: 100%;
  }

  .search {
    flex: 1 1;
  }

  .savebar {
    left: 1rem;
    right: 1rem;
    transform: none;
    justify-content: space-between;
  }
}

@media (max-width: 560px) {
  /* Line tables collapse into stacked cards */
  .lines__table thead {
    display: none;
  }

  .lines__table,
  .lines__table tbody,
  .lines__table tr,
  .lines__table td,
  .lines__table th[scope='row'] {
    display: block;
    width: 100%;
  }

  .lines__table tr {
    position: relative;
    padding: 0.5rem 0;
    border-bottom: 1px solid var(--line);
  }

  .lines__table td {
    border: 0;
    padding: 0.2rem 0;
  }

  .lines__table td[data-label]::before {
    content: attr(data-label);
    display: block;
    font-size: 0.8rem;
    font-weight: 600;
    color: var(--muted);
  }

  .lines__index {
    display: none !important;
  }

  .lines__remove {
    position: absolute;
    top: 0.3rem;
    inset-inline-end: 0;
    width: auto !important;
  }
}

@media (prefers-reduced-motion: reduce) {
  *,
  *::before,
  *::after {
    animation-duration: 0.01ms !important;
    transition-duration: 0.01ms !important;
  }
}

/* ---------- Skeleton (loading placeholders) ---------- */

.skeleton {
  display: block;
  background: var(--secondary, #f3f4f6);
  border-radius: var(--radius-sm, 6px);
  position: relative;
  overflow: hidden;
}

.skeleton--circle {
  border-radius: 999px;
}

.skeleton::after {
  content: '';
  position: absolute;
  inset: 0;
  transform: translateX(-100%);
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.6), transparent);
  animation: skeleton-shimmer 1.6s ease-in-out infinite;
}

@keyframes skeleton-shimmer {
  100% {
    transform: translateX(100%);
  }
}

.dashboard-skeleton__greeting {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.dashboard-skeleton__stats {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(130px, 1fr));
  gap: 0.6rem;
}

.dashboard-skeleton__stat {
  padding: 0.75rem 0.9rem;
  border-radius: var(--radius);
  border: 1px solid var(--line-soft);
  border-inline-start: 4px solid var(--line-soft);
  background: var(--surface);
  box-shadow: var(--shadow);
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.dashboard-skeleton__card {
  padding: 1rem 1.1rem;
  border-radius: var(--radius);
  border: 1px solid var(--line-soft);
  background: var(--surface);
  box-shadow: var(--shadow);
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.dashboard-skeleton__card-head {
  display: flex;
  align-items: center;
  gap: 0.6rem;
}

.dashboard-skeleton__card-lines {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  gap: 0.4rem;
}

/* ---------- Review panel (sheet) ---------- */

.sheet-backdrop {
  position: fixed;
  inset: 0;
  z-index: 1300;
  background: rgba(17, 24, 39, 0.5);
}

.sheet {
  position: fixed;
  top: 0;
  bottom: 0;
  inset-inline-end: 0;
  width: min(480px, 100%);
  display: flex;
  flex-direction: column;
  background: var(--surface);
  box-shadow: var(--shadow-lg);
  border-inline-start: 1px solid var(--line-soft);
}

.sheet__loading {
  flex: 1 1;
  display: grid;
  place-items: center;
  padding: 2rem;
}

.sheet__header {
  flex-shrink: 0;
  padding: 1.1rem 1.3rem;
  border-bottom: 1px solid var(--line-soft);
  display: flex;
  flex-direction: column;
  gap: 0.85rem;
}

.sheet__title-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.6rem;
}

.sheet__title-row h2,
.sheet__title-row h3 {
  font-size: 1.05rem;
  margin: 0;
}

.sheet__report-head {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
}

.sheet__meta-row {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  flex-wrap: wrap;
}

.sheet__code {
  font-family: var(--font-mono, monospace);
  font-size: 0.8rem;
  color: var(--ink-2);
}

.sheet__divider {
  width: 1px;
  height: 16px;
  background: var(--line);
}

.sheet__engineer {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  font-size: 0.88rem;
  color: var(--ink-2);
}

.sheet__avatar {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border-radius: 999px;
  background: var(--brand-soft);
  color: var(--brand);
  font-size: 0.65rem;
  font-weight: 700;
}

.sheet__body {
  flex: 1 1;
  overflow-y: auto;
  padding: 1.1rem 1.3rem;
  display: flex;
  flex-direction: column;
  gap: 1.3rem;
}

.sheet__sections-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 0.88rem;
  font-weight: 600;
  margin-bottom: 0.4rem;
}

.sheet__footer {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  gap: 0.6rem;
  padding: 0.9rem 1.3rem;
  border-top: 1px solid var(--line-soft);
}

.sheet__footer p {
  flex: 1 1;
  margin: 0;
}

.review-panel__list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0.1rem;
}

.review-panel__row {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  padding: 0.45rem 0.4rem;
  border-radius: var(--radius-sm);
}

.review-panel__row:hover {
  background: var(--secondary, #fafbfc);
}

.review-panel__label {
  flex: 1 1;
  font-size: 0.88rem;
}

.review-panel__composer {
  padding: 0.5rem 0.4rem 0.8rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.review-panel__decision {
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
}

.radio-card {
  display: flex;
  align-items: center;
  gap: 0.85rem;
  padding: 1rem;
  border: 1px solid var(--line-soft);
  border-radius: var(--radius);
  background: var(--surface);
  text-align: start;
  cursor: pointer;
}

.radio-card.is-checked {
  border: 2px solid var(--brand);
  background: var(--brand-soft);
  padding: 0.95rem;
}

.radio-card__radio {
  flex-shrink: 0;
  width: 16px;
  height: 16px;
  border: 1px solid var(--line);
  border-radius: 999px;
  background: var(--bg);
}

.radio-card.is-checked .radio-card__radio {
  border: 5px solid var(--brand);
  background: var(--surface);
}

.radio-card__icon {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: var(--radius-sm);
  background: var(--bg);
}

.radio-card__text {
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
}

.profile-summary {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 1rem;
}

.profile-summary > div:first-of-type {
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
}

.profile-summary__meta {
  display: flex;
  flex-wrap: wrap;
  gap: 1.5rem;
  margin-inline-start: auto;
}

.profile-summary__meta dt {
  font-size: 0.8rem;
  color: var(--muted);
}

.profile-summary__meta dd {
  margin: 0;
  font-weight: 600;
}

.radio-card-row {
  display: flex;
  gap: 0.75rem;
}

.radio-card-row .radio-card {
  flex: 1 1;
}

/* ---------- Report lifecycle tracker ---------- */

.lifecycle {
  background: var(--surface);
  border: 1px solid var(--line-soft);
  border-radius: var(--radius);
  box-shadow: var(--shadow);
  padding: 1.25rem 1.5rem 1rem;
}

.lifecycle__steps {
  display: flex;
  align-items: flex-start;
  list-style: none;
  margin: 0;
  padding: 0;
}

.lifecycle__step {
  display: flex;
  flex: 1 1;
  min-width: 0;
  flex-direction: column;
  align-items: center;
  position: relative;
  text-align: center;
  gap: 0.3rem;
}

.lifecycle__connector {
  position: absolute;
  top: 15px;
  inset-inline-end: 50%;
  width: 100%;
  height: 2px;
  background: var(--line-soft);
}

.lifecycle__step.is-reached .lifecycle__connector,
.lifecycle__step.is-current .lifecycle__connector,
.lifecycle__step.is-returned .lifecycle__connector {
  background: var(--complete);
}

.lifecycle__step.is-returned .lifecycle__connector {
  background: var(--missing);
}

.lifecycle__dot {
  z-index: 1;
  display: grid;
  place-items: center;
  width: 32px;
  height: 32px;
  border-radius: 999px;
  background: var(--surface);
  border: 2px solid var(--line);
  color: var(--ink-2);
  font-size: 0.85rem;
  font-weight: 700;
}

.lifecycle__step.is-reached .lifecycle__dot {
  background: var(--complete);
  border-color: var(--complete);
  color: #fff;
}

.lifecycle__step.is-current .lifecycle__dot {
  background: var(--created-bg);
  border-color: var(--created);
  color: var(--created);
}

.lifecycle__step.is-returned .lifecycle__dot {
  background: var(--missing);
  border-color: var(--missing);
  color: #fff;
}

.lifecycle__label {
  font-size: 0.88rem;
  font-weight: 600;
  color: var(--ink);
}

.lifecycle__meta {
  font-size: 0.78rem;
  color: var(--ink-2);
}

.lifecycle__reason {
  display: flex;
  align-items: flex-start;
  gap: 0.4rem;
  margin: 0.9rem 0 0;
  padding: 0.6rem 0.8rem;
  border-radius: var(--radius-sm);
  background: var(--missing-bg);
  color: var(--missing);
  font-size: 0.85rem;
}

/* ---------- Collapsible section card ---------- */

.collapsible-card {
  padding: 0;
  overflow: hidden;
}

.collapsible-card__header {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem 1rem;
  padding: 0.85rem 1.1rem;
}

.collapsible-card__toggle {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  flex: 1 1 auto;
  min-width: 0;
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  text-align: start;
  color: inherit;
  font: inherit;
}

.collapsible-card__chevron {
  flex-shrink: 0;
  color: var(--ink-2);
  transition: transform 150ms ease;
}

.collapsible-card__chevron.is-collapsed {
  transform: rotate(-90deg);
}

[dir='rtl'] .collapsible-card__chevron.is-collapsed {
  transform: rotate(90deg);
}

.collapsible-card__icon {
  display: grid;
  place-items: center;
  flex-shrink: 0;
  width: 32px;
  height: 32px;
  border-radius: var(--radius-sm);
  background: var(--secondary, #f3f4f6);
  color: var(--ink-2);
}

.collapsible-card__title {
  font-size: 1.08rem;
  font-weight: 700;
  color: var(--ink);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.collapsible-card__end {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.5rem;
}

.collapsible-card__body {
  padding: 0 1.1rem 1.1rem;
  border-top: 1px solid var(--line-soft);
  padding-top: 1.1rem;
}

/* ---------- Approval card (dashboard) ---------- */

.approval-card-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
  gap: 1rem;
}

.approval-card {
  display: flex;
  flex-direction: column;
  gap: 0.7rem;
  padding: 1rem;
  background: var(--surface);
  border: 1px solid var(--line-soft);
  border-radius: var(--radius);
  box-shadow: var(--shadow);
}

.approval-card__head {
  display: flex;
  align-items: flex-start;
  gap: 0.6rem;
}

.approval-card__avatar {
  flex-shrink: 0;
  display: grid;
  place-items: center;
  width: 32px;
  height: 32px;
  border-radius: 999px;
  background: var(--brand-soft);
  color: var(--brand);
  font-size: 0.78rem;
  font-weight: 700;
}

.approval-card__who {
  flex: 1 1 auto;
  min-width: 0;
}

.approval-card__name {
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.approval-card__time {
  flex-shrink: 0;
  white-space: nowrap;
}

.approval-card__meta {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
}

.approval-card__kpis {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.kpi-chip {
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  padding: 0.25rem 0.55rem;
  border-radius: var(--radius-sm);
  background: var(--secondary, #f3f4f6);
  color: var(--ink-2);
  font-size: 0.8rem;
}

.kpi-chip strong {
  color: var(--ink);
  font-variant-numeric: tabular-nums;
}

.approval-card__actions {
  display: flex;
  gap: 0.5rem;
  margin-top: auto;
}

.approval-card__actions .btn {
  flex: 1 1;
  justify-content: center;
}

/* ---------- Compliance card (report submission this week) ---------- */

.compliance-card {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.compliance-card__row {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.compliance-card__site {
  flex: 1 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: 500;
}

.compliance-card__row--head .compliance-card__site {
  font-weight: 400;
}

.compliance-card__days {
  display: flex;
  gap: 0.4rem;
  flex-shrink: 0;
}

.compliance-day-label {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  overflow: hidden;
  font-size: 0.72rem;
  line-height: 1;
  white-space: nowrap;
  color: var(--ink-2);
}

.compliance-day {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: var(--radius-sm);
  color: var(--ink-2);
}

.compliance-day--onTime {
  background: var(--success-subtle, #ecfdf3);
  color: var(--success, #027a48);
}

.compliance-day--late {
  background: var(--warning-subtle, #fffaeb);
  color: var(--warning-subtle-foreground, #b54708);
}

.compliance-day--missed {
  background: var(--danger-subtle, #fef3f2);
  color: var(--danger-subtle-foreground, #b42318);
}

.compliance-day--none {
  background: var(--secondary, #f3f4f6);
  color: var(--ink-2);
}

.compliance-day--upcoming {
  border: 1px dashed var(--line);
}

.compliance-day--legend {
  width: 14px;
  height: 14px;
  border-radius: 4px;
}

.compliance-card__rate {
  flex-shrink: 0;
  width: 44px;
  text-align: end;
  font-weight: 600;
  font-variant-numeric: tabular-nums;
}

.compliance-card__legend {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 1rem;
  margin-top: 0.4rem;
  padding-top: 0.6rem;
  border-top: 1px solid var(--line-soft);
  font-size: 0.78rem;
  color: var(--ink-2);
}

.compliance-card__legend span {
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
}

/* ---------- Report status chart (report status by site) ---------- */

.status-chart {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.status-chart__plot {
  width: 100%;
}

.status-chart__legend {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  font-size: 0.8rem;
  color: var(--ink-2);
}

.status-chart__legend span {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
}

.status-chart__swatch {
  width: 10px;
  height: 10px;
  border-radius: 2px;
}

.chart-tooltip {
  min-width: 160px;
  padding: 0.5rem 0.65rem;
  background: var(--surface);
  border: 1px solid var(--line-soft);
  border-radius: var(--radius-sm);
  box-shadow: var(--shadow-lg);
  font-size: 0.8rem;
}

.chart-tooltip__title {
  margin: 0 0 0.35rem;
  font-weight: 600;
}

.chart-tooltip__row {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.1rem 0;
}

.chart-tooltip__row--total {
  margin-top: 0.3rem;
  padding-top: 0.3rem;
  border-top: 1px solid var(--line-soft);
}

.chart-tooltip__dot {
  width: 8px;
  height: 8px;
  border-radius: 2px;
  flex-shrink: 0;
}

.chart-tooltip__label {
  flex: 1 1 auto;
  color: var(--ink-2);
}

.export-split {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 1rem;
}
`, "",{"version":3,"sources":["webpack://./src/styles/index.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,qBAAqB;EACrB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;;EAEhB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;EACrB,cAAc;EACd,iBAAiB;;EAEjB,cAAc;EACd,gBAAgB;EAChB,4EAA4E;EAC5E,+CAA+C;EAC/C,6FAA6F;AAC/F;;AAEA;;qDAEqD;AACrD;EACE,uBAAuB;EACvB,oCAAoC;EACpC,mCAAmC;EACnC,wBAAwB;EACxB,2BAA2B;EAC3B,gCAAgC;EAChC,qBAAqB;EACrB,0BAA0B;EAC1B,uBAAuB;EACvB,sBAAsB;;EAEtB,0BAA0B;EAC1B,oCAAoC;EACpC,sBAAsB;EACtB,gCAAgC;EAChC,uBAAuB;EACvB,iCAAiC;EACjC,wBAAwB;EACxB,kCAAkC;EAClC,8BAA8B;EAC9B,0BAA0B;;EAE1B,oEAAoE;EACpE,2CAA2C;EAC3C,kBAAkB;AACpB;;AAEA;;;EAGE,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,SAAS;EACT,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;;;;EAIE,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;;EAIE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,UAAU;EACV,YAAY;EACZ,oBAAoB;EACpB,sBAAsB;EACtB,WAAW;EACX,+BAA+B;AACjC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA,iCAAiC;;AAEjC;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,0BAA0B;EAC1B,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,mEAAmE;AACrE;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,WAAW;AACb;;AAEA,6CAA6C;;AAE7C;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;EACpB,yCAAyC;EACzC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA,yCAAyC;;AAEzC;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,sBAAsB;EACtB,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;EAChB,oCAAoC;EACpC,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,wBAAwB;EACxB,oBAAoB;EACpB,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,wBAAwB;EACxB,WAAW;AACb;;AAEA;EACE,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,2CAA2C;EAC3C,kCAAkC;EAClC,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF;;AAEA,kCAAkC;;AAElC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,qBAAqB;EACrB,+BAA+B;EAC/B,6BAA6B;EAC7B,0BAA0B;EAC1B,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,mBAAmB;EACnB,kFAAkF;AACpF;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,wBAAwB;EACxB,0BAA0B;EAC1B,WAAW;AACb;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;EAC3B,6BAA6B;EAC7B,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,4BAA4B;EAC5B,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,6BAA6B;EAC7B,+BAA+B;EAC/B,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;AACvB;;AAEA,gCAAgC;;AAEhC;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,uBAAuB;EACvB,uCAAuC;EACvC,+BAA+B;EAC/B,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,0BAA0B;EAC1B,0CAA0C;EAC1C,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,QAAQ;EACR,2BAA2B;EAC3B,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,+BAA+B;EAC/B,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,4BAA4B;EAC5B,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,qBAAqB;EACrB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA,gCAAgC;;AAEhC;EACE,0BAA0B;EAC1B,kCAAkC;EAClC,4BAA4B;EAC5B,yBAAyB;EACzB,kBAAkB;EAClB,oBAAoB;EACpB,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,iCAAiC;;AAEjC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,sBAAsB;EACtB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,WAAW;EACX,uBAAuB;EACvB,4BAA4B;EAC5B,kCAAkC;EAClC,2CAA2C;EAC3C,0BAA0B;EAC1B,yBAAyB;EACzB,iBAAiB;EACjB,cAAc;EACd,qBAAqB;AACvB;;AAEA;;EAEE,eAAe;EACf,0DAA0D;AAC5D;;AAEA;;EAEE,iCAAiC;AACnC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,SAAO;EACP,WAAW;EACX,eAAe;EACf,oBAAoB;EACpB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,wBAAwB;EACxB,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;;AAEA,wDAAwD;;AAExD;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,oBAAoB;EACpB,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,MAAM;EACN,YAAY;EACZ,wBAAwB;EACxB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,YAAY;EACZ,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,wBAAwB;EACxB,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,4BAA4B;EAC5B,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA,yDAAyD;;AAEzD;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,YAAY;EACZ,mBAAmB;AACrB;;AAEA,+CAA+C;;AAE/C;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,6BAA6B;EAC7B,WAAW;AACb;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA,4DAA4D;;AAE5D;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,0BAA0B;EAC1B,6BAA6B;EAC7B,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB,+BAA+B;EAC/B,0BAA0B;EAC1B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,0CAA0C;AAC5C;;AAEA;EACE,SAAS;EACT,aAAa;EACb,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,YAAY;EACZ,+BAA+B;EAC/B,4BAA4B;EAC5B,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,SAAS;EACT,uBAAuB;EACvB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,0BAA0B;EAC1B,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,SAAS;EACT,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,uCAAuC;AACzC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,SAAS;EACT,WAAW;EACX,mCAAmC;AACrC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;EACjB,yCAAyC;EACzC;oGACkG;EAClG,qCAAqC;EACrC,uCAAuC;EACvC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,0CAA0C;EAC1C,mCAAmC;AACrC;;AAEA,iCAAiC;;AAEjC;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,qCAAqC;EACrC,uBAAuB;EACvB,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,yCAAyC;EACzC,sBAAsB;AACxB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;;EAEE,0CAA0C;AAC5C;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;;EAIE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,SAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,wBAAwB;EACxB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,0BAA0B;EAC1B,6BAA6B;EAC7B,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kCAAkC;EAClC,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,yBAAyB;AAC3B;;AAEA,mCAAmC;;AAEnC;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mDAAmD;EACnD,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,WAAW;EACX,WAAW;EACX,gBAAgB;EAChB,sBAAsB;EACtB,+BAA+B;EAC/B,6BAA6B;EAC7B,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,yCAAyC;EACzC,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yCAAyC;EACzC,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,QAAQ;EACR,8BAA8B;AAChC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,oBAAoB;EACpB,UAAU;EACV,sBAAsB;AACxB;;AAEA,2BAA2B,2BAA2B,EAAE;AACxD,0BAA0B,0BAA0B,EAAE;AACtD,wBAAwB,wBAAwB,EAAE;AAClD,0BAA0B,0BAA0B,EAAE;AACtD,sBAAsB,sBAAsB,EAAE;;AAE9C;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;EACV,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,oCAAoC;EACpC,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,mCAAmC;;AAEnC;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,0BAA0B;EAC1B,kCAAkC;EAClC,kCAAkC;EAClC,4BAA4B;EAC5B,yBAAyB;EACzB,iBAAiB;EACjB,qBAAqB;EACrB,iCAAiC;AACnC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,sCAAsC;;AAEtC;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,WAAW;EACX,sBAAsB;EACtB,6BAA6B;EAC7B,+BAA+B;EAC/B,0BAA0B;EAC1B,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;EAC1B,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,UAAU;EACV,aAAa;EACb,cAAc;EACd,oBAAoB;EACpB,4BAA4B;EAC5B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;EAEE,wBAAwB;EACxB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,uBAAuB;EACvB,kCAAkC;EAClC,+BAA+B;EAC/B,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,8BAA8B;EAC9B,+BAA+B;EAC/B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,oBAAoB;EACpB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,2DAA2D;AAC7D;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,aAAa;EACb,WAAW;EACX,iBAAiB;AACnB;;AAEA;;EAEE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;;EAEE,SAAS;AACX;;AAEA;EACE,2DAA2D;EAC3D,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,wCAAwC;;AAExC;EACE,aAAa;EACb,eAAe;EACf,qBAAqB;EACrB,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,WAAW;EACX,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,oBAAoB;EACpB,6BAA6B;EAC7B,0BAA0B;EAC1B,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,2CAA2C;EAC3C,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;EACtB,oCAAoC;AACtC;;AAEA;EACE,uBAAuB;EACvB,yCAAyC;EACzC,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,yCAAyC;EACzC,sBAAsB;EACtB,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,iCAAiC;AACnC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,eAAe;EACf,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,6BAA6B;EAC7B,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,SAAS;EACT,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,UAAU;EACV,aAAa;EACb,4DAA4D;EAC5D,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,UAAU;EACV,6BAA6B;EAC7B,+BAA+B;EAC/B,0BAA0B;EAC1B,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,qBAAqB;EACrB,qCAAqC;EACrC,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,+BAA+B;EAC/B,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,2CAA2C;EAC3C,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;EACnB,kCAAkC;EAClC,+BAA+B;AACjC;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;;;EAGE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,4BAA4B;EAC5B,sBAAsB;EACtB,0CAA0C;EAC1C,2BAA2B;AAC7B;;AAEA;EACE,sCAAsC;EACtC,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,wBAAwB;EACxB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,yCAAyC;EACzC,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,oCAAoC;EACpC,4BAA4B;EAC5B,sBAAsB;EACtB,WAAW;EACX,oBAAoB;EACpB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,0BAA0B;EAC1B,6BAA6B;EAC7B,4BAA4B;EAC5B,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,uBAAuB;EACvB,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA,iCAAiC;;AAEjC;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,qBAAqB;EACrB,+BAA+B;EAC/B,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,8BAA8B;EAC9B,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA,yDAAyD;;AAEzD;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,4DAA4D;EAC5D,WAAW;AACb;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,mBAAmB;EACnB,WAAW;EACX,WAAW;EACX,gBAAgB;EAChB,6BAA6B;EAC7B,+BAA+B;EAC/B,0BAA0B;EAC1B,iBAAiB;EACjB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,iBAAiB;EACjB,yCAAyC;AAC3C;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;AACb;;AAEA,mCAAmC;;AAEnC;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,8BAA8B;EAC9B,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,uBAAuB;EACvB,0BAA0B;EAC1B,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,oCAAoC;EACpC,+BAA+B;EAC/B,0BAA0B;EAC1B,6BAA6B;EAC7B,8CAA8C;EAC9C,4BAA4B;EAC5B,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;AACF;;AAEA,+BAA+B;;AAE/B;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,mBAAmB;EACnB,uCAAuC;EACvC,gBAAgB;EAChB,gBAAgB;EAChB,0BAA0B;EAC1B,iBAAiB;EACjB,6BAA6B;EAC7B,4BAA4B;EAC5B,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,sBAAsB;EACtB,yCAAyC;AAC3C;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,WAAW;EACX,WAAW;EACX,sBAAsB;EACtB,SAAS;EACT,yCAAyC;EACzC,0BAA0B;EAC1B,iBAAiB;EACjB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA,gCAAgC;;AAEhC;EACE,eAAe;EACf,QAAQ;EACR,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,8BAA8B;EAC9B,0BAA0B;EAC1B,4BAA4B;EAC5B,4BAA4B;AAC9B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,sBAAsB;EACtB,yCAAyC;AAC3C;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,eAAe;EACf,WAAW;EACX,sBAAsB;EACtB,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;EACZ,0BAA0B;EAC1B,4BAA4B;EAC5B,uCAAuC;AACzC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,SAAO;AACT;;AAEA;EACE;IACE,qDAAqD;EACvD;EACA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,0BAA0B;EAC1B,kCAAkC;EAClC,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,sCAAsC;EACtC,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,sCAAsC;EACtC,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,yCAAyC;AAC3C;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,qCAAqC;;AAErC;EACE;IACE,qCAAqC;EACvC;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,SAAO;EACT;;EAEA;IACE,UAAU;IACV,WAAW;IACX,eAAe;IACf,8BAA8B;EAChC;AACF;;AAEA;EACE,4CAA4C;EAC5C;IACE,aAAa;EACf;;EAEA;;;;;IAKE,cAAc;IACd,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;IACjB,oCAAoC;EACtC;;EAEA;IACE,SAAS;IACT,iBAAiB;EACnB;;EAEA;IACE,yBAAyB;IACzB,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,mBAAmB;IACnB,sBAAsB;EACxB;AACF;;AAEA;EACE;;;IAGE,qCAAqC;IACrC,sCAAsC;EACxC;AACF;;AAEA,0DAA0D;;AAE1D;EACE,cAAc;EACd,qCAAqC;EACrC,oCAAoC;EACpC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,4BAA4B;EAC5B,sFAAsF;EACtF,qDAAqD;AACvD;;AAEA;EACE;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,4BAA4B;EAC5B,kCAAkC;EAClC,+CAA+C;EAC/C,0BAA0B;EAC1B,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,4BAA4B;EAC5B,kCAAkC;EAClC,0BAA0B;EAC1B,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,WAAW;AACb;;AAEA,+CAA+C;;AAE/C;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,MAAM;EACN,SAAS;EACT,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,0BAA0B;EAC1B,4BAA4B;EAC5B,+CAA+C;AACjD;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,yCAAyC;EACzC,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;AACb;;AAEA;;EAEE,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,wCAAwC;EACxC,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,sBAAsB;EACtB,sCAAsC;AACxC;;AAEA;EACE,SAAO;EACP,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,+BAA+B;AACjC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,SAAO;EACP,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,kCAAkC;EAClC,4BAA4B;EAC5B,0BAA0B;EAC1B,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,SAAO;AACT;;AAEA,mDAAmD;;AAEnD;EACE,0BAA0B;EAC1B,kCAAkC;EAClC,4BAA4B;EAC5B,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,SAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,qBAAqB;EACrB,WAAW;EACX,WAAW;EACX,4BAA4B;AAC9B;;AAEA;;;EAGE,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,0BAA0B;EAC1B,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,6BAA6B;EAC7B,WAAW;AACb;;AAEA;EACE,6BAA6B;EAC7B,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;EAC1B,4BAA4B;EAC5B,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,+BAA+B;EAC/B,6BAA6B;EAC7B,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA,mDAAmD;;AAEnD;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,wBAAwB;EACxB,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA,oDAAoD;;AAEpD;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,aAAa;EACb,0BAA0B;EAC1B,kCAAkC;EAClC,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,wBAAwB;EACxB,+BAA+B;EAC/B,qCAAqC;EACrC,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,SAAW;EACX,uBAAuB;AACzB;;AAEA,wEAAwE;;AAExE;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,SAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,0CAA0C;EAC1C,8BAA8B;AAChC;;AAEA;EACE,0CAA0C;EAC1C,gDAAgD;AAClD;;AAEA;EACE,yCAAyC;EACzC,+CAA+C;AACjD;;AAEA;EACE,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,sCAAsC;EACtC,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;AACb;;AAEA,sEAAsE;;AAEtE;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,0BAA0B;EAC1B,kCAAkC;EAClC,+BAA+B;EAC/B,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX","sourcesContent":[":root {\r\n  --brand: #6b1d1d;\r\n  --brand-strong: #521313;\r\n  --brand-soft: #f7ecec;\r\n  --ink: #111827;\r\n  --ink-2: #374151;\r\n  --muted: #5b6472;\r\n  --line: #d6dae1;\r\n  --line-soft: #e8ebf0;\r\n  --bg: #f4f5f7;\r\n  --surface: #ffffff;\r\n  --focus: #1d4ed8;\r\n\r\n  --complete: #166534;\r\n  --complete-bg: #dcfce7;\r\n  --created: #1e40af;\r\n  --created-bg: #dbeafe;\r\n  --draft: #92400e;\r\n  --draft-bg: #fef3c7;\r\n  --missing: #991b1b;\r\n  --missing-bg: #fee2e2;\r\n  --new: #334155;\r\n  --new-bg: #eef1f5;\r\n\r\n  --radius: 10px;\r\n  --radius-sm: 6px;\r\n  --shadow: 0 1px 2px rgba(17, 24, 39, 0.06), 0 1px 3px rgba(17, 24, 39, 0.08);\r\n  --shadow-lg: 0 12px 32px rgba(17, 24, 39, 0.18);\r\n  --font: 'IBM Plex Sans Arabic', 'Noto Sans Arabic', 'Segoe UI', Tahoma, system-ui, sans-serif;\r\n}\r\n\r\n/* Dark mode: bridges this file's own token names to the already-dark-ready\r\n   palette in styles/tokens/tokens.css (which shares the same .dark class),\r\n   instead of hand-authoring a second full palette. */\r\n.dark {\r\n  --brand: var(--primary);\r\n  --brand-strong: var(--primary-hover);\r\n  --brand-soft: var(--primary-subtle);\r\n  --ink: var(--foreground);\r\n  --ink-2: var(--text-subtle);\r\n  --muted: var(--muted-foreground);\r\n  --line: var(--border);\r\n  --line-soft: var(--border);\r\n  --bg: var(--background);\r\n  --surface: var(--card);\r\n\r\n  --complete: var(--success);\r\n  --complete-bg: var(--success-subtle);\r\n  --created: var(--info);\r\n  --created-bg: var(--info-subtle);\r\n  --draft: var(--warning);\r\n  --draft-bg: var(--warning-subtle);\r\n  --missing: var(--danger);\r\n  --missing-bg: var(--danger-subtle);\r\n  --new: var(--muted-foreground);\r\n  --new-bg: var(--secondary);\r\n\r\n  --shadow: 0 1px 2px rgba(0, 0, 0, 0.4), 0 1px 3px rgba(0, 0, 0, 0.5);\r\n  --shadow-lg: 0 12px 32px rgba(0, 0, 0, 0.6);\r\n  color-scheme: dark;\r\n}\r\n\r\n*,\r\n*::before,\r\n*::after {\r\n  box-sizing: border-box;\r\n}\r\n\r\nhtml {\r\n  -webkit-text-size-adjust: 100%;\r\n}\r\n\r\nbody {\r\n  margin: 0;\r\n  font-family: var(--font);\r\n  font-size: 15px;\r\n  line-height: 1.6;\r\n  color: var(--ink);\r\n  background: var(--bg);\r\n}\r\n\r\nh1,\r\nh2,\r\nh3,\r\np {\r\n  margin: 0;\r\n}\r\n\r\nh1 {\r\n  font-size: 1.5rem;\r\n  font-weight: 700;\r\n  line-height: 1.3;\r\n}\r\n\r\na {\r\n  color: var(--brand);\r\n}\r\n\r\nbutton,\r\ninput,\r\nselect,\r\ntextarea {\r\n  font: inherit;\r\n  color: inherit;\r\n}\r\n\r\n:focus-visible {\r\n  outline: 3px solid var(--focus);\r\n  outline-offset: 2px;\r\n}\r\n\r\n.sr-only {\r\n  position: absolute;\r\n  width: 1px;\r\n  height: 1px;\r\n  padding: 0;\r\n  margin: -1px;\r\n  overflow: hidden;\r\n  clip: rect(0, 0, 0, 0);\r\n  white-space: nowrap;\r\n  border: 0;\r\n}\r\n\r\n.skip-link {\r\n  position: absolute;\r\n  inset-inline-start: 1rem;\r\n  top: -3rem;\r\n  z-index: 100;\r\n  padding: 0.5rem 1rem;\r\n  background: var(--ink);\r\n  color: #fff;\r\n  border-radius: var(--radius-sm);\r\n}\r\n\r\n.skip-link:focus {\r\n  top: 0.5rem;\r\n}\r\n\r\n.muted {\r\n  color: var(--muted);\r\n}\r\n\r\n.small {\r\n  font-size: 0.85rem;\r\n}\r\n\r\n.num {\r\n  font-variant-numeric: tabular-nums;\r\n  white-space: nowrap;\r\n}\r\n\r\n.ltr-cell {\r\n  text-align: end;\r\n}\r\n\r\n.icon {\r\n  flex-shrink: 0;\r\n}\r\n\r\n/* ---------- Layout ---------- */\r\n\r\n.brand__mark {\r\n  display: grid;\r\n  place-items: center;\r\n  width: 38px;\r\n  height: 38px;\r\n  border-radius: 9px;\r\n  background: var(--surface);\r\n  color: var(--brand);\r\n  font-weight: 700;\r\n  letter-spacing: 0.02em;\r\n  direction: ltr;\r\n}\r\n\r\n.main {\r\n  flex: 1;\r\n  width: 100%;\r\n  max-width: 1440px;\r\n  margin: 0 auto;\r\n  padding: clamp(1rem, 2.5vw, 1.75rem) clamp(0.75rem, 3vw, 2rem) 5rem;\r\n}\r\n\r\n.main:focus {\r\n  outline: none;\r\n}\r\n\r\n.page {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 1rem;\r\n}\r\n\r\n.page__head {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 0.75rem 1rem;\r\n}\r\n\r\n.toolbar {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  align-items: center;\r\n  gap: 0.5rem;\r\n}\r\n\r\n/* ---------- Site detail header ---------- */\r\n\r\n.site-head {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  align-items: center;\r\n  gap: 0.5rem 1.5rem;\r\n  padding-bottom: 1rem;\r\n  border-bottom: 1px solid var(--line-soft);\r\n  margin-bottom: 1rem;\r\n}\r\n\r\n.site-head__title {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.6rem;\r\n  flex-basis: 100%;\r\n}\r\n\r\n.site-head__title h1 {\r\n  margin: 0;\r\n}\r\n\r\n.site-head__meta {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 0.25rem 1rem;\r\n  color: var(--muted);\r\n  font-size: 0.9rem;\r\n}\r\n\r\n.site-head__meta span {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 0.3rem;\r\n}\r\n\r\n.site-head__people {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 1.5rem;\r\n}\r\n\r\n.site-head__person {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.5rem;\r\n}\r\n\r\n.site-head__person-text {\r\n  display: flex;\r\n  flex-direction: column;\r\n  line-height: 1.3;\r\n}\r\n\r\n.site-head__person strong {\r\n  font-size: 0.88rem;\r\n}\r\n\r\n.site-head__person small {\r\n  color: var(--muted);\r\n  font-size: 0.78rem;\r\n}\r\n\r\n.site-head__edit {\r\n  margin-inline-start: auto;\r\n}\r\n\r\n.stack {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.6rem;\r\n}\r\n\r\n/* ---------- Project header ---------- */\r\n\r\n.project {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 1rem;\r\n}\r\n\r\n.project__head {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.5rem;\r\n}\r\n\r\n.crumbs {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.4rem;\r\n  font-size: 0.95rem;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.crumbs span[aria-current] {\r\n  font-weight: 600;\r\n}\r\n\r\n.project__meta {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  align-items: center;\r\n  gap: 0.4rem 1rem;\r\n  color: var(--muted);\r\n  font-size: 0.9rem;\r\n}\r\n\r\n.tabs {\r\n  display: flex;\r\n  gap: 0.25rem;\r\n  overflow-x: auto;\r\n  overflow-y: hidden;\r\n  border-bottom: 1px solid var(--line);\r\n  scrollbar-width: thin;\r\n}\r\n\r\n.tab {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 0.4rem;\r\n  padding: 0.6rem 0.9rem;\r\n  color: var(--ink-2);\r\n  text-decoration: none;\r\n  font-weight: 500;\r\n  border-bottom: 3px solid transparent;\r\n  margin-bottom: -1px;\r\n  white-space: nowrap;\r\n  min-height: 44px;\r\n}\r\n\r\n.tab:hover {\r\n  color: var(--brand);\r\n}\r\n\r\n.tab.is-active {\r\n  color: var(--brand);\r\n  border-bottom-color: var(--brand);\r\n  font-weight: 600;\r\n}\r\n\r\n.tab.is-disabled {\r\n  color: var(--muted);\r\n  cursor: default;\r\n}\r\n\r\n.chip {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 0.25rem;\r\n  padding: 0.05rem 0.55rem;\r\n  border-radius: 999px;\r\n  background: var(--new-bg);\r\n  color: var(--ink-2);\r\n  font-size: 0.8rem;\r\n  font-weight: 500;\r\n  white-space: nowrap;\r\n}\r\n\r\n.chip--today {\r\n  margin-inline-start: 0.4rem;\r\n  background: var(--brand);\r\n  color: #fff;\r\n}\r\n\r\n.chip--info {\r\n  background: var(--created-bg);\r\n  color: var(--created);\r\n}\r\n\r\n.chip--warning {\r\n  background: var(--draft-bg);\r\n  color: var(--draft);\r\n}\r\n\r\n.weather-row {\r\n  display: grid;\r\n  grid-template-columns: repeat(7, minmax(0, 1fr));\r\n  gap: 0.6rem;\r\n}\r\n\r\n.weather-day {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  gap: 0.25rem;\r\n  padding: 0.8rem 0.5rem;\r\n  text-align: center;\r\n  background: var(--surface-muted, var(--bg));\r\n  border: 1px solid var(--line-soft);\r\n  border-radius: var(--radius);\r\n}\r\n\r\n.weather-day--alert {\r\n  background: var(--draft-bg);\r\n  border-color: var(--draft);\r\n}\r\n\r\n.weather-day__alert {\r\n  margin-top: 0.3rem;\r\n  font-size: 0.75rem;\r\n  font-weight: 600;\r\n  color: var(--draft);\r\n}\r\n\r\n@media (max-width: 900px) {\r\n  .weather-row {\r\n    grid-template-columns: repeat(4, minmax(0, 1fr));\r\n  }\r\n}\r\n\r\n/* ---------- Buttons ---------- */\r\n\r\n.btn {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 0.45rem;\r\n  min-height: 42px;\r\n  padding: 0.45rem 1rem;\r\n  border-radius: var(--radius-sm);\r\n  border: 1px solid var(--line);\r\n  background: var(--surface);\r\n  color: var(--ink);\r\n  font-weight: 600;\r\n  text-decoration: none;\r\n  cursor: pointer;\r\n  white-space: nowrap;\r\n  transition: background-color 150ms ease, border-color 150ms ease, color 150ms ease;\r\n}\r\n\r\n.btn:hover:not(:disabled) {\r\n  background: #f3f4f6;\r\n}\r\n\r\n.btn:disabled {\r\n  cursor: not-allowed;\r\n  opacity: 0.55;\r\n}\r\n\r\n.btn--sm {\r\n  min-height: 34px;\r\n  padding: 0.25rem 0.7rem;\r\n  font-size: 0.875rem;\r\n}\r\n\r\n.btn--block {\r\n  width: 100%;\r\n}\r\n\r\n.btn--primary {\r\n  background: var(--brand);\r\n  border-color: var(--brand);\r\n  color: #fff;\r\n}\r\n\r\n.btn--primary:hover:not(:disabled) {\r\n  background: var(--brand-strong);\r\n}\r\n\r\n.btn--success {\r\n  background: var(--complete);\r\n  border-color: var(--complete);\r\n  color: #fff;\r\n}\r\n\r\n.btn--success:hover:not(:disabled) {\r\n  background: #14532d;\r\n}\r\n\r\n.btn--danger {\r\n  background: var(--surface);\r\n  border-color: #fca5a5;\r\n  color: var(--missing);\r\n}\r\n\r\n.btn--danger:hover:not(:disabled) {\r\n  background: var(--missing-bg);\r\n}\r\n\r\n.btn--ghost {\r\n  background: transparent;\r\n  border-color: transparent;\r\n  color: var(--brand);\r\n}\r\n\r\n.btn--ghost:hover:not(:disabled) {\r\n  background: var(--brand-soft);\r\n}\r\n\r\n.btn--required {\r\n  border-color: var(--missing);\r\n  color: var(--missing);\r\n  border-style: dashed;\r\n}\r\n\r\n.icon-button {\r\n  display: inline-grid;\r\n  place-items: center;\r\n  width: 38px;\r\n  height: 38px;\r\n  padding: 0;\r\n  border: 1px solid transparent;\r\n  border-radius: var(--radius-sm);\r\n  background: transparent;\r\n  color: var(--ink-2);\r\n  cursor: pointer;\r\n}\r\n\r\n.icon-button:hover:not(:disabled) {\r\n  background: #eef0f3;\r\n  color: var(--ink);\r\n}\r\n\r\n.icon-button:disabled {\r\n  opacity: 0.4;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.rot-90 .icon {\r\n  transform: rotate(90deg);\r\n}\r\n\r\n.link-button {\r\n  border: 0;\r\n  background: none;\r\n  padding: 0.25rem;\r\n  color: var(--brand);\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  text-decoration: underline;\r\n  text-underline-offset: 2px;\r\n}\r\n\r\n.link-button--danger {\r\n  color: var(--missing);\r\n}\r\n\r\n/* ---------- Forms ---------- */\r\n\r\n.field {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.3rem;\r\n  min-width: 0;\r\n}\r\n\r\n.field__label {\r\n  font-weight: 600;\r\n  font-size: 0.9rem;\r\n  color: var(--ink-2);\r\n}\r\n\r\n.field__required {\r\n  color: var(--missing);\r\n}\r\n\r\n.field__hint {\r\n  font-size: 0.82rem;\r\n  color: var(--muted);\r\n}\r\n\r\n.field__error {\r\n  font-size: 0.85rem;\r\n  color: var(--missing);\r\n  font-weight: 500;\r\n}\r\n\r\n.input {\r\n  width: 100%;\r\n  min-height: 42px;\r\n  padding: 0.45rem 0.7rem;\r\n  border: 1px solid var(--input, #b9bfc9);\r\n  border-radius: var(--radius-sm);\r\n  background: var(--surface);\r\n  color: var(--ink);\r\n}\r\n\r\n.input:hover {\r\n  border-color: var(--border-strong, #8b93a1);\r\n}\r\n\r\n.input:focus {\r\n  border-color: var(--focus);\r\n  outline: 2px solid rgba(29, 78, 216, 0.25);\r\n  outline-offset: 0;\r\n}\r\n\r\n.input[aria-invalid='true'] {\r\n  border-color: var(--missing);\r\n}\r\n\r\n.field__control {\r\n  position: relative;\r\n  display: flex;\r\n}\r\n\r\n.field__control .input {\r\n  padding-inline-end: 2.5rem;\r\n}\r\n\r\n.field__adornment {\r\n  position: absolute;\r\n  inset-inline-end: 0.3rem;\r\n  top: 50%;\r\n  transform: translateY(-50%);\r\n  display: inline-grid;\r\n  place-items: center;\r\n  width: 32px;\r\n  height: 32px;\r\n  border: 0;\r\n  border-radius: var(--radius-sm);\r\n  background: transparent;\r\n  color: var(--muted);\r\n  cursor: pointer;\r\n}\r\n\r\n.field__adornment:hover {\r\n  background: #eef0f3;\r\n}\r\n\r\n.field__adornment--static {\r\n  cursor: default;\r\n}\r\n\r\n.field__adornment--static:hover {\r\n  background: transparent;\r\n}\r\n\r\n.input--area {\r\n  min-height: 64px;\r\n  resize: vertical;\r\n  line-height: 1.5;\r\n}\r\n\r\n.input--compact {\r\n  min-height: 36px;\r\n  padding: 0.2rem 0.5rem;\r\n  width: auto;\r\n}\r\n\r\ninput[type='number'].input {\r\n  direction: ltr;\r\n  text-align: right;\r\n}\r\n\r\ninput[type='date'].input {\r\n  direction: ltr;\r\n  text-align: right;\r\n}\r\n\r\n.checkbox {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 0.5rem;\r\n  font-weight: 500;\r\n}\r\n\r\n.checkbox input,\r\ntd input[type='checkbox'] {\r\n  width: 18px;\r\n  height: 18px;\r\n  accent-color: var(--brand);\r\n}\r\n\r\n.form-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(2, minmax(0, 1fr));\r\n  gap: 0.9rem 1rem;\r\n}\r\n\r\n.span-2 {\r\n  grid-column: 1 / -1;\r\n}\r\n\r\n.location-map {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.45rem;\r\n}\r\n\r\n.location-map__head {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 0.75rem;\r\n}\r\n\r\n.location-map__frame {\r\n  position: relative;\r\n}\r\n\r\n.location-map__canvas {\r\n  height: 320px;\r\n  border: 1px solid var(--line-soft);\r\n  border-radius: var(--radius);\r\n  overflow: hidden;\r\n  background: #eef1f4;\r\n}\r\n\r\n.location-map__status {\r\n  position: absolute;\r\n  inset: 0;\r\n  display: grid;\r\n  place-items: center;\r\n  color: var(--muted);\r\n  font-size: 0.9rem;\r\n  pointer-events: none;\r\n}\r\n\r\n.pac-container {\r\n  z-index: 10000;\r\n  font-family: inherit;\r\n}\r\n\r\n.form-actions {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  gap: 0.5rem;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.inline-form {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  align-items: flex-end;\r\n  gap: 0.6rem;\r\n  margin-top: 1rem;\r\n}\r\n\r\n.inline-form .field {\r\n  flex: 1 1 200px;\r\n}\r\n\r\n.filters {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  align-items: flex-end;\r\n  gap: 0.75rem 1rem;\r\n}\r\n\r\n.filters .field {\r\n  flex: 0 1 240px;\r\n}\r\n\r\n/* ---------- Cards ---------- */\r\n\r\n.card {\r\n  background: var(--surface);\r\n  border: 1px solid var(--line-soft);\r\n  border-radius: var(--radius);\r\n  box-shadow: var(--shadow);\r\n  position: relative;\r\n  padding: 1rem 1.1rem;\r\n  min-width: 0;\r\n  scroll-margin-top: 120px;\r\n}\r\n\r\n.card__header {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 0.5rem 1rem;\r\n  margin-bottom: 0.85rem;\r\n}\r\n\r\n.card__title {\r\n  font-size: 1.08rem;\r\n  font-weight: 700;\r\n  color: var(--ink);\r\n}\r\n\r\n.card__actions {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  align-items: flex-end;\r\n  gap: 0.5rem;\r\n}\r\n\r\n.subhead {\r\n  margin: 1rem 0 0.5rem;\r\n  font-size: 0.95rem;\r\n  font-weight: 600;\r\n  color: var(--ink-2);\r\n}\r\n\r\n/* ---------- Status ---------- */\r\n\r\n.badge {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 0.3rem;\r\n  padding: 0.1rem 0.6rem;\r\n  border-radius: 999px;\r\n  font-size: 0.82rem;\r\n  font-weight: 600;\r\n  white-space: nowrap;\r\n  border: 1px solid transparent;\r\n}\r\n\r\n.badge::before {\r\n  content: '';\r\n  width: 7px;\r\n  height: 7px;\r\n  border-radius: 50%;\r\n  background: currentColor;\r\n}\r\n\r\n.badge--complete {\r\n  background: var(--complete-bg);\r\n  color: var(--complete);\r\n}\r\n\r\n.badge--created {\r\n  background: var(--created-bg);\r\n  color: var(--created);\r\n}\r\n\r\n.badge--draft {\r\n  background: var(--draft-bg);\r\n  color: var(--draft);\r\n}\r\n\r\n.badge--missing {\r\n  background: var(--missing-bg);\r\n  color: var(--missing);\r\n}\r\n\r\n.badge--new {\r\n  background: var(--new-bg);\r\n  color: var(--new);\r\n  border-color: var(--line);\r\n}\r\n\r\n.badge--project-active {\r\n  background: var(--complete-bg);\r\n  color: var(--complete);\r\n}\r\n\r\n.badge--project-on_hold {\r\n  background: var(--draft-bg);\r\n  color: var(--draft);\r\n}\r\n\r\n.badge--project-completed {\r\n  background: var(--created-bg);\r\n  color: var(--created);\r\n}\r\n\r\n.stats {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(130px, 1fr));\r\n  gap: 0.6rem;\r\n}\r\n\r\n.stat {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: flex-start;\r\n  gap: 0.1rem;\r\n  padding: 0.75rem 0.9rem;\r\n  border-radius: var(--radius);\r\n  border: 1px solid var(--line-soft);\r\n  border-inline-start: 4px solid var(--ink-2);\r\n  background: var(--surface);\r\n  box-shadow: var(--shadow);\r\n  text-align: start;\r\n  color: inherit;\r\n  text-decoration: none;\r\n}\r\n\r\nbutton.stat,\r\na.stat {\r\n  cursor: pointer;\r\n  transition: border-color 150ms ease, box-shadow 150ms ease;\r\n}\r\n\r\nbutton.stat:hover,\r\na.stat:hover {\r\n  box-shadow: 0 0 0 1px var(--line);\r\n}\r\n\r\nbutton.stat.is-active {\r\n  box-shadow: 0 0 0 2px var(--ink);\r\n}\r\n\r\n.stat__value {\r\n  font-size: 1.6rem;\r\n  font-weight: 700;\r\n  line-height: 1.2;\r\n  font-variant-numeric: tabular-nums;\r\n}\r\n\r\n.stat__label {\r\n  font-size: 0.88rem;\r\n  color: var(--ink-2);\r\n  font-weight: 500;\r\n}\r\n\r\n.stat--complete {\r\n  border-inline-start-color: var(--complete);\r\n}\r\n\r\n.stat--created {\r\n  border-inline-start-color: var(--created);\r\n}\r\n\r\n.stat--draft {\r\n  border-inline-start-color: #d97706;\r\n}\r\n\r\n.stat--missing {\r\n  border-inline-start-color: var(--missing);\r\n}\r\n\r\n.stat--new {\r\n  border-inline-start-color: #94a3b8;\r\n}\r\n\r\n.stats--static .stat {\r\n  border-inline-start-color: var(--brand);\r\n}\r\n\r\n.progress {\r\n  flex: 1;\r\n  height: 8px;\r\n  min-width: 60px;\r\n  border-radius: 999px;\r\n  background: var(--line-soft);\r\n  overflow: hidden;\r\n}\r\n\r\n.progress span {\r\n  display: block;\r\n  height: 100%;\r\n  background: var(--brand);\r\n  border-radius: inherit;\r\n}\r\n\r\n.progress--good span {\r\n  background: var(--complete);\r\n}\r\n\r\n.progress--warn span {\r\n  background: var(--draft);\r\n}\r\n\r\n.progress--danger span {\r\n  background: var(--missing);\r\n}\r\n\r\n.avatar-stack {\r\n  display: flex;\r\n  flex-direction: row;\r\n  align-items: center;\r\n}\r\n\r\n.avatar-stack__item {\r\n  width: 26px;\r\n  height: 26px;\r\n  font-size: 0.72rem;\r\n  margin-inline-start: -8px;\r\n  border: 2px solid var(--surface);\r\n}\r\n\r\n.avatar-stack__item:first-child {\r\n  margin-inline-start: 0;\r\n}\r\n\r\n.avatar-stack__more {\r\n  margin-inline-start: 0.35rem;\r\n  font-size: 0.78rem;\r\n  color: var(--muted);\r\n}\r\n\r\n.fill {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.5rem;\r\n  min-width: 120px;\r\n}\r\n\r\n/* ---------- Ring / plan-bar (Sites cards) ---------- */\r\n\r\n.ring__label {\r\n  font-size: 0.95rem;\r\n  font-weight: 700;\r\n  fill: var(--ink);\r\n}\r\n\r\n.plan-bar {\r\n  position: relative;\r\n  height: 8px;\r\n  border-radius: 999px;\r\n  background: var(--line-soft);\r\n  overflow: visible;\r\n}\r\n\r\n.plan-bar__fill {\r\n  position: absolute;\r\n  inset-inline-start: 0;\r\n  top: 0;\r\n  height: 100%;\r\n  background: var(--brand);\r\n  border-radius: 999px;\r\n}\r\n\r\n.plan-bar__tick {\r\n  position: absolute;\r\n  top: -3px;\r\n  width: 2px;\r\n  height: 14px;\r\n  background: var(--ink);\r\n  transform: translateX(-1px);\r\n}\r\n\r\n.legend {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.6rem;\r\n  font-size: 0.82rem;\r\n  color: var(--muted);\r\n}\r\n\r\n.legend__item {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 0.35rem;\r\n}\r\n\r\n.legend__dot {\r\n  width: 8px;\r\n  height: 8px;\r\n  border-radius: 50%;\r\n  background: var(--brand);\r\n  flex-shrink: 0;\r\n}\r\n\r\n.legend__dot--planned {\r\n  background: var(--ink);\r\n}\r\n\r\n.divider {\r\n  height: 1px;\r\n  background: var(--line-soft);\r\n  border: none;\r\n  margin: 0;\r\n}\r\n\r\n.site-card__head {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.9rem;\r\n}\r\n\r\n.site-card__plan {\r\n  flex: 1;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.4rem;\r\n  min-width: 0;\r\n}\r\n\r\n.site-card__plan-head {\r\n  display: flex;\r\n  align-items: baseline;\r\n  justify-content: space-between;\r\n  gap: 0.5rem;\r\n  font-weight: 600;\r\n}\r\n\r\n.plan-ahead {\r\n  color: var(--complete);\r\n  font-weight: 600;\r\n}\r\n\r\n.plan-behind {\r\n  color: var(--draft);\r\n  font-weight: 600;\r\n}\r\n\r\n.plan-onplan {\r\n  color: var(--muted);\r\n  font-weight: 600;\r\n}\r\n\r\n.site-card__last {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 0.5rem;\r\n  font-size: 0.85rem;\r\n}\r\n\r\n.site-card__prep {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.6rem;\r\n}\r\n\r\n.site-card__prep .shell__avatar {\r\n  width: 32px;\r\n  height: 32px;\r\n  font-size: 0.85rem;\r\n}\r\n\r\n.site-card__prep-name {\r\n  display: flex;\r\n  flex-direction: column;\r\n  line-height: 1.3;\r\n}\r\n\r\n.site-card__prep-name strong {\r\n  font-size: 0.88rem;\r\n}\r\n\r\n.site-card__prep-name small {\r\n  color: var(--muted);\r\n  font-size: 0.78rem;\r\n}\r\n\r\n.status-list {\r\n  list-style: none;\r\n  margin: 0;\r\n  padding: 0;\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 0.5rem 1.5rem;\r\n}\r\n\r\n.status-list li {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.5rem;\r\n}\r\n\r\n.today-icon {\r\n  display: grid;\r\n  place-items: center;\r\n  flex-shrink: 0;\r\n  width: 32px;\r\n  height: 32px;\r\n  border-radius: var(--radius-sm);\r\n  background: var(--secondary, #f3f4f6);\r\n  color: var(--ink-2);\r\n}\r\n\r\n.today-recent {\r\n  list-style: none;\r\n  margin: 0;\r\n  padding: 0;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.2rem;\r\n}\r\n\r\n.today-recent__row {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.65rem;\r\n  padding: 0.55rem 0;\r\n  border-bottom: 1px solid var(--line-soft);\r\n}\r\n\r\n.today-recent__row:last-child {\r\n  border-bottom: none;\r\n}\r\n\r\n.today-recent__body {\r\n  flex: 1;\r\n  min-width: 0;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.15rem;\r\n}\r\n\r\n.today-recent__body .code-link {\r\n  font-weight: 700;\r\n}\r\n\r\n/* ---------- \"Continue today's report\" card ---------- */\r\n\r\n.today-continue__head {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.75rem;\r\n}\r\n\r\n.today-continue__text {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.1rem;\r\n}\r\n\r\n.today-continue__heading {\r\n  font-weight: 700;\r\n  color: var(--ink);\r\n}\r\n\r\n.today-continue__progress-label {\r\n  margin: 0.85rem 0 0.4rem;\r\n  font-size: 0.9rem;\r\n  font-weight: 600;\r\n  color: var(--ink-2);\r\n}\r\n\r\n.today-continue__footer {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  flex-wrap: wrap;\r\n  gap: 0.75rem;\r\n  margin-top: 0.85rem;\r\n}\r\n\r\n/* ---------- \"Today's tasks\" card ---------- */\r\n\r\n.today-tasks {\r\n  list-style: none;\r\n  margin: 0;\r\n  padding: 0;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.2rem;\r\n}\r\n\r\n.today-tasks__row {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  gap: 0.65rem;\r\n  padding: 0.55rem 0;\r\n  border-bottom: 1px solid var(--line-soft);\r\n}\r\n\r\n.today-tasks__row:last-child {\r\n  border-bottom: none;\r\n}\r\n\r\n.today-tasks__status {\r\n  display: grid;\r\n  place-items: center;\r\n  flex-shrink: 0;\r\n  width: 20px;\r\n  height: 20px;\r\n  margin-top: 0.15rem;\r\n  border-radius: 50%;\r\n  border: 2px solid var(--line);\r\n  color: transparent;\r\n}\r\n\r\n.today-tasks__row.is-done .today-tasks__status {\r\n  background: var(--complete);\r\n  border-color: var(--complete);\r\n  color: #fff;\r\n}\r\n\r\n.today-tasks__body {\r\n  flex: 1;\r\n  min-width: 0;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.15rem;\r\n}\r\n\r\n.today-tasks__title {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 0.35rem;\r\n  font-weight: 600;\r\n  color: var(--ink);\r\n  text-decoration: none;\r\n}\r\n\r\n.today-tasks__title:hover {\r\n  text-decoration: underline;\r\n}\r\n\r\n.today-tasks__row.is-done .today-tasks__title {\r\n  color: var(--ink-2);\r\n  text-decoration: line-through;\r\n}\r\n\r\n/* ---------- Month switch / search / segmented ---------- */\r\n\r\n.month-switch {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.25rem;\r\n  background: var(--surface);\r\n  border: 1px solid var(--line);\r\n  border-radius: var(--radius);\r\n  padding: 0.2rem;\r\n}\r\n\r\n.month-switch__select {\r\n  border: 0;\r\n  background: transparent;\r\n  font-size: 1.2rem;\r\n  font-weight: 700;\r\n  padding: 0.25rem 0.5rem;\r\n  min-height: 40px;\r\n  cursor: pointer;\r\n}\r\n\r\n.search {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.4rem;\r\n  padding: 0 0.6rem;\r\n  border: 1px solid #b9bfc9;\r\n  border-radius: var(--radius-sm);\r\n  background: var(--surface);\r\n  color: var(--muted);\r\n  min-height: 40px;\r\n}\r\n\r\n.search:focus-within {\r\n  border-color: var(--focus);\r\n  outline: 2px solid rgba(29, 78, 216, 0.25);\r\n}\r\n\r\n.search input {\r\n  border: 0;\r\n  outline: none;\r\n  background: transparent;\r\n  min-width: 190px;\r\n  color: var(--ink);\r\n}\r\n\r\n.segmented {\r\n  display: inline-flex;\r\n  padding: 3px;\r\n  border-radius: var(--radius-sm);\r\n  background: var(--line-soft);\r\n  gap: 2px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.segmented button {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 0.35rem;\r\n  border: 0;\r\n  background: transparent;\r\n  padding: 0.35rem 0.8rem;\r\n  border-radius: 5px;\r\n  font-weight: 600;\r\n  color: var(--ink-2);\r\n  cursor: pointer;\r\n  min-height: 36px;\r\n}\r\n\r\n.segmented button[aria-pressed='true'],\r\n.segmented button[aria-selected='true'] {\r\n  background: var(--surface);\r\n  color: var(--brand);\r\n  box-shadow: var(--shadow);\r\n}\r\n\r\n.tabs-list {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 1.5rem;\r\n  border-bottom: 1px solid var(--line);\r\n}\r\n\r\n.tabs-trigger {\r\n  position: relative;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 0.5rem;\r\n  height: 40px;\r\n  padding: 0 0.25rem;\r\n  background: transparent;\r\n  border: 0;\r\n  cursor: pointer;\r\n  font-size: 0.85rem;\r\n  font-weight: 500;\r\n  color: var(--muted-foreground, #4b5563);\r\n}\r\n\r\n.tabs-trigger[aria-selected='true'] {\r\n  color: var(--foreground, #111928);\r\n}\r\n\r\n.tabs-trigger[aria-selected='true']::after {\r\n  content: '';\r\n  position: absolute;\r\n  inset-inline: 0;\r\n  bottom: 0;\r\n  height: 2px;\r\n  background: var(--primary, #6b1d1d);\r\n}\r\n\r\n.tabs-trigger__count {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  height: 20px;\r\n  padding: 0 0.5rem;\r\n  border-radius: var(--radius-full, 9999px);\r\n  /* NOTE: --muted here means \"muted text color\" (#5b6472, set in this file's own :root above),\r\n     not the tokens.css background meaning (#f3f4f6) — use --secondary instead to avoid the clash. */\r\n  background: var(--secondary, #f3f4f6);\r\n  color: var(--muted-foreground, #4b5563);\r\n  font-size: 0.75rem;\r\n  font-weight: 500;\r\n}\r\n\r\n.tabs-trigger[aria-selected='true'] .tabs-trigger__count {\r\n  background: var(--primary-subtle, #f7ecec);\r\n  color: var(--primary-text, #6b1d1d);\r\n}\r\n\r\n/* ---------- Tables ---------- */\r\n\r\n.table-wrap {\r\n  position: relative;\r\n  overflow-x: auto;\r\n  margin: 0 -1.1rem;\r\n  padding: 0 1.1rem;\r\n}\r\n\r\n.table {\r\n  width: 100%;\r\n  border-collapse: collapse;\r\n  font-size: 0.93rem;\r\n}\r\n\r\n.table th {\r\n  text-align: start;\r\n  font-weight: 600;\r\n  color: var(--ink-2);\r\n  background: var(--secondary, #f7f8fa);\r\n  padding: 0.55rem 0.7rem;\r\n  border-bottom: 1px solid var(--line);\r\n  white-space: nowrap;\r\n}\r\n\r\n.table td {\r\n  padding: 0.55rem 0.7rem;\r\n  border-bottom: 1px solid var(--line-soft);\r\n  vertical-align: middle;\r\n}\r\n\r\n.table tbody tr:hover {\r\n  background: var(--secondary, #fafbfc);\r\n}\r\n\r\n.table tbody tr.is-selected,\r\n.table tbody tr.is-selected:hover {\r\n  background: var(--primary-subtle, #f7ecec);\r\n}\r\n\r\n.table tr.is-today {\r\n  background: var(--brand-soft);\r\n}\r\n\r\n.table tr.is-inactive td {\r\n  color: var(--muted);\r\n}\r\n\r\n.table--compact th,\r\n.table--compact td,\r\n[data-density='compact'] .table th,\r\n[data-density='compact'] .table td {\r\n  padding: 0.25rem 0.5rem;\r\n}\r\n\r\n[data-density='compact'] .card {\r\n  padding: 0.7rem 0.85rem;\r\n}\r\n\r\n[data-density='compact'] .card__header {\r\n  margin-bottom: 0.5rem;\r\n}\r\n\r\n.table-footer {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  align-items: center;\r\n  gap: 0.75rem;\r\n  padding-top: 0.85rem;\r\n}\r\n\r\n.table-footer .spacer {\r\n  flex: 1 0 0;\r\n  min-width: 1rem;\r\n}\r\n\r\n.table-footer__rows {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.5rem;\r\n  font-size: 0.85rem;\r\n  color: var(--ink-2);\r\n  font-weight: 500;\r\n}\r\n\r\n.table-footer__rows select {\r\n  width: auto;\r\n  min-height: 32px;\r\n}\r\n\r\n.table-footer__pagination {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.35rem;\r\n}\r\n\r\n.dropdown {\r\n  position: relative;\r\n}\r\n\r\n.dropdown summary {\r\n  list-style: none;\r\n}\r\n\r\n.dropdown summary::-webkit-details-marker {\r\n  display: none;\r\n}\r\n\r\n.dropdown[open] summary {\r\n  box-shadow: 0 0 0 2px var(--ink);\r\n}\r\n\r\n.dropdown__panel {\r\n  position: absolute;\r\n  z-index: 20;\r\n  top: calc(100% + 0.3rem);\r\n  inset-inline-end: 0;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.4rem;\r\n  min-width: 180px;\r\n  padding: 0.6rem;\r\n  background: var(--surface);\r\n  border: 1px solid var(--line);\r\n  border-radius: var(--radius-sm);\r\n  box-shadow: var(--shadow-lg);\r\n}\r\n\r\n.dropdown__item {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.5rem;\r\n  font-size: 0.9rem;\r\n  cursor: pointer;\r\n}\r\n\r\n.code-link {\r\n  font-weight: 700;\r\n  font-variant-numeric: tabular-nums;\r\n  text-decoration: none;\r\n  white-space: nowrap;\r\n  direction: ltr;\r\n  unicode-bidi: isolate;\r\n}\r\n\r\n.code-link:hover {\r\n  text-decoration: underline;\r\n}\r\n\r\n.count {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 0.25rem;\r\n}\r\n\r\n.row-actions {\r\n  display: flex;\r\n  gap: 0.15rem;\r\n  justify-content: flex-end;\r\n}\r\n\r\n/* ---------- Calendar ---------- */\r\n\r\n.calendar {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 4px;\r\n  overflow-x: auto;\r\n}\r\n\r\n.calendar__row {\r\n  display: grid;\r\n  grid-template-columns: repeat(7, minmax(76px, 1fr));\r\n  gap: 4px;\r\n}\r\n\r\n.calendar__row--head div {\r\n  text-align: center;\r\n  font-weight: 600;\r\n  font-size: 0.85rem;\r\n  color: var(--ink-2);\r\n  padding: 0.3rem 0;\r\n}\r\n\r\n.calendar__row--head .is-weekend {\r\n  color: var(--brand);\r\n}\r\n\r\n.calendar__cellwrap {\r\n  display: flex;\r\n}\r\n\r\n.calendar__cell {\r\n  position: relative;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: flex-start;\r\n  gap: 0.1rem;\r\n  width: 100%;\r\n  min-height: 88px;\r\n  padding: 0.4rem 0.5rem;\r\n  border-radius: var(--radius-sm);\r\n  border: 1px solid var(--line);\r\n  background: var(--surface);\r\n  text-align: start;\r\n}\r\n\r\nbutton.calendar__cell {\r\n  cursor: pointer;\r\n  border-inline-start-width: 4px;\r\n}\r\n\r\nbutton.calendar__cell:hover {\r\n  box-shadow: 0 0 0 2px var(--line);\r\n}\r\n\r\n.calendar__cell.is-blank {\r\n  background: transparent;\r\n  border-color: transparent;\r\n}\r\n\r\n.calendar__cell.is-out {\r\n  background: #f1f2f4;\r\n  color: var(--muted);\r\n}\r\n\r\n.calendar__cell.is-today {\r\n  box-shadow: 0 0 0 2px var(--brand);\r\n}\r\n\r\n.calendar__day {\r\n  font-weight: 700;\r\n  font-size: 1.05rem;\r\n  font-variant-numeric: tabular-nums;\r\n}\r\n\r\n.calendar__code {\r\n  font-size: 0.8rem;\r\n  font-weight: 600;\r\n  direction: ltr;\r\n}\r\n\r\n.calendar__status {\r\n  font-size: 0.78rem;\r\n  font-weight: 600;\r\n}\r\n\r\n.calendar__attach {\r\n  position: absolute;\r\n  top: 0.4rem;\r\n  inset-inline-end: 0.45rem;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 2px;\r\n  font-size: 0.75rem;\r\n  color: var(--ink-2);\r\n}\r\n\r\n.calendar__cell--complete {\r\n  border-inline-start-color: var(--complete);\r\n  background: #f3fbf5;\r\n}\r\n\r\n.calendar__cell--complete .calendar__status {\r\n  color: var(--complete);\r\n}\r\n\r\n.calendar__cell--created {\r\n  border-inline-start-color: var(--created);\r\n  background: #f4f7fe;\r\n}\r\n\r\n.calendar__cell--created .calendar__status {\r\n  color: var(--created);\r\n}\r\n\r\n.calendar__cell--draft {\r\n  border-inline-start-color: #d97706;\r\n  background: #fffbeb;\r\n}\r\n\r\n.calendar__cell--draft .calendar__status {\r\n  color: var(--draft);\r\n}\r\n\r\n.calendar__cell--missing {\r\n  border-inline-start-color: var(--missing);\r\n  background: #fef5f5;\r\n}\r\n\r\n.calendar__cell--missing .calendar__status {\r\n  color: var(--missing);\r\n}\r\n\r\n.calendar__cell--new {\r\n  border-inline-start-color: #94a3b8;\r\n}\r\n\r\n.calendar__cell--new .calendar__status {\r\n  color: var(--new);\r\n}\r\n\r\n.calendar__cell--portfolio {\r\n  min-height: 112px;\r\n  gap: 2px;\r\n  border-inline-start-width: 1px;\r\n}\r\n\r\n.calendar__cell.is-selected {\r\n  box-shadow: 0 0 0 2px var(--brand);\r\n}\r\n\r\n.calendar__project {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 4px;\r\n  max-width: 100%;\r\n  font-size: 0.72rem;\r\n  font-weight: 600;\r\n  line-height: 1.2;\r\n}\r\n\r\n.calendar__project-name {\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n}\r\n\r\n.calendar__dot {\r\n  width: 8px;\r\n  height: 8px;\r\n  border-radius: 999px;\r\n  flex: none;\r\n  background: var(--new);\r\n}\r\n\r\n.calendar__dot--complete { background: var(--complete); }\r\n.calendar__dot--created { background: var(--created); }\r\n.calendar__dot--draft { background: var(--draft); }\r\n.calendar__dot--missing { background: var(--missing); }\r\n.calendar__dot--new { background: var(--new); }\r\n\r\n.calendar__more {\r\n  font-size: 0.72rem;\r\n  font-weight: 600;\r\n  color: var(--muted);\r\n}\r\n\r\n.calendar-legend {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 0.75rem 1rem;\r\n  list-style: none;\r\n  margin: 0 0 1rem;\r\n  padding: 0;\r\n  font-size: 0.8rem;\r\n  font-weight: 600;\r\n}\r\n\r\n.calendar-legend li {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 0.35rem;\r\n}\r\n\r\n.calendar-day {\r\n  list-style: none;\r\n  margin: 0;\r\n  padding: 0;\r\n}\r\n\r\n.calendar-day a {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.75rem;\r\n  padding: 0.7rem 0;\r\n  border-bottom: 1px solid var(--line);\r\n  color: inherit;\r\n  text-decoration: none;\r\n}\r\n\r\n.calendar-day a:hover {\r\n  color: var(--brand);\r\n}\r\n\r\n.calendar-day__project {\r\n  font-weight: 600;\r\n  margin-inline-end: auto;\r\n}\r\n\r\n/* ---------- Projects ---------- */\r\n\r\n.project-grid {\r\n  list-style: none;\r\n  margin: 0;\r\n  padding: 0;\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\r\n  gap: 1rem;\r\n}\r\n\r\n.project-card {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.6rem;\r\n  height: 100%;\r\n  padding: 1.1rem;\r\n  background: var(--surface);\r\n  border: 1px solid var(--line-soft);\r\n  border-top: 4px solid var(--brand);\r\n  border-radius: var(--radius);\r\n  box-shadow: var(--shadow);\r\n  color: var(--ink);\r\n  text-decoration: none;\r\n  transition: box-shadow 150ms ease;\r\n}\r\n\r\n.project-card:hover {\r\n  box-shadow: var(--shadow-lg);\r\n}\r\n\r\n/* ---------- New project ---------- */\r\n\r\n.stepper {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 0.5rem;\r\n  margin: 0;\r\n  padding: 0;\r\n  list-style: none;\r\n}\r\n\r\n.stepper li {\r\n  flex: 1 1 180px;\r\n}\r\n\r\n.stepper button {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.6rem;\r\n  width: 100%;\r\n  padding: 0.6rem 0.8rem;\r\n  border: 1px solid var(--line);\r\n  border-radius: var(--radius-sm);\r\n  background: var(--surface);\r\n  color: var(--muted);\r\n  font: inherit;\r\n  font-weight: 600;\r\n  text-align: start;\r\n}\r\n\r\n.stepper li.is-done button {\r\n  color: var(--ink);\r\n  cursor: pointer;\r\n}\r\n\r\n.stepper li.is-done button:hover {\r\n  border-color: var(--brand);\r\n}\r\n\r\n.stepper li.is-current button {\r\n  border-color: var(--brand);\r\n  background: var(--brand-soft);\r\n  color: var(--brand);\r\n}\r\n\r\n.stepper__index {\r\n  display: inline-grid;\r\n  place-items: center;\r\n  flex: none;\r\n  width: 1.6rem;\r\n  height: 1.6rem;\r\n  border-radius: 999px;\r\n  background: var(--line-soft);\r\n  color: var(--ink-2);\r\n  font-size: 0.85rem;\r\n}\r\n\r\n.stepper li.is-current .stepper__index,\r\n.stepper li.is-done .stepper__index {\r\n  background: var(--brand);\r\n  color: #fff;\r\n}\r\n\r\n.team-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));\r\n  gap: 1rem;\r\n}\r\n\r\n.team-card {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.75rem;\r\n}\r\n\r\n.team-card > .btn {\r\n  align-self: flex-start;\r\n}\r\n\r\n.team-list {\r\n  display: grid;\r\n  gap: 0.4rem;\r\n  margin: 0;\r\n  padding: 0;\r\n  list-style: none;\r\n}\r\n\r\n.team-list li {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 0.5rem;\r\n  padding: 0.45rem 0.6rem;\r\n  border: 1px solid var(--line-soft);\r\n  border-radius: var(--radius-sm);\r\n  background: var(--bg);\r\n}\r\n\r\n.team-list li div {\r\n  display: flex;\r\n  flex-direction: column;\r\n  min-width: 0;\r\n}\r\n\r\n.team-list .ltr-cell {\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n\r\n.team-empty {\r\n  padding: 0.6rem;\r\n  border: 1px dashed var(--line);\r\n  border-radius: var(--radius-sm);\r\n  color: var(--muted);\r\n  text-align: center;\r\n}\r\n\r\n.summary-list {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));\r\n  gap: 0.75rem 1.25rem;\r\n  margin: 0;\r\n}\r\n\r\n.summary-list dt {\r\n  color: var(--muted);\r\n  font-size: 0.88rem;\r\n  font-weight: 500;\r\n}\r\n\r\n.summary-list dd {\r\n  margin: 0;\r\n  font-weight: 600;\r\n}\r\n\r\n.stats--wide {\r\n  grid-template-columns: repeat(auto-fit, minmax(170px, 1fr));\r\n}\r\n\r\n.stat__value.code-link {\r\n  font-size: 1.1rem;\r\n}\r\n\r\n.project-card__top {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  color: var(--brand);\r\n}\r\n\r\n.project-card h2 {\r\n  font-size: 1.05rem;\r\n  line-height: 1.5;\r\n}\r\n\r\n.project-card dl,\r\n.info-grid {\r\n  display: grid;\r\n  gap: 0.35rem;\r\n  margin: 0;\r\n}\r\n\r\n.project-card dl div {\r\n  display: flex;\r\n  gap: 0.5rem;\r\n  font-size: 0.9rem;\r\n}\r\n\r\n.project-card dt,\r\n.info-grid dt {\r\n  color: var(--muted);\r\n  font-weight: 500;\r\n}\r\n\r\n.project-card dd,\r\n.info-grid dd {\r\n  margin: 0;\r\n}\r\n\r\n.info-grid {\r\n  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\r\n  gap: 0.9rem 1.25rem;\r\n}\r\n\r\n.info-grid dt {\r\n  font-size: 0.85rem;\r\n  margin-bottom: 0.15rem;\r\n}\r\n\r\n.info-grid dd {\r\n  font-weight: 500;\r\n}\r\n\r\n/* ---------- Report editor ---------- */\r\n\r\n.report__head {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  align-items: flex-end;\r\n  justify-content: space-between;\r\n  gap: 0.75rem 1rem;\r\n}\r\n\r\n.report__title {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.25rem;\r\n}\r\n\r\n.report__nav {\r\n  display: flex;\r\n  gap: 0.25rem;\r\n  margin-inline-start: -0.7rem;\r\n}\r\n\r\n.report__title .code {\r\n  white-space: nowrap;\r\n  direction: ltr;\r\n  unicode-bidi: isolate;\r\n  color: var(--brand);\r\n}\r\n\r\n.report__date {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  align-items: center;\r\n  gap: 0.5rem;\r\n  color: var(--ink-2);\r\n  font-weight: 500;\r\n}\r\n\r\n.section-nav {\r\n  position: sticky;\r\n  top: 58px;\r\n  z-index: 20;\r\n  display: flex;\r\n  gap: 0.35rem;\r\n  overflow-x: auto;\r\n  padding: 0.5rem 0;\r\n  background: var(--bg);\r\n  scrollbar-width: thin;\r\n}\r\n\r\n.section-nav a {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 0.25rem;\r\n  padding: 0.3rem 0.75rem;\r\n  border-radius: 999px;\r\n  border: 1px solid var(--line);\r\n  background: var(--surface);\r\n  color: var(--ink-2);\r\n  font-size: 0.87rem;\r\n  font-weight: 500;\r\n  text-decoration: none;\r\n  white-space: nowrap;\r\n  min-height: 34px;\r\n}\r\n\r\n.section-nav a:hover {\r\n  border-color: var(--brand);\r\n  color: var(--brand);\r\n}\r\n\r\n.section-nav a.is-filled {\r\n  border-color: #86efac;\r\n  background: var(--complete-bg);\r\n  color: var(--complete);\r\n}\r\n\r\n.report__layout {\r\n  display: grid;\r\n  grid-template-columns: minmax(0, 1fr) 320px;\r\n  gap: 1rem;\r\n  align-items: start;\r\n}\r\n\r\n.report__main {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 1rem;\r\n  min-width: 0;\r\n}\r\n\r\n.report__aside {\r\n  position: sticky;\r\n  top: 112px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 1rem;\r\n}\r\n\r\n.lines {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: flex-start;\r\n  gap: 0.5rem;\r\n}\r\n\r\n.lines__table {\r\n  width: 100%;\r\n  border-collapse: collapse;\r\n}\r\n\r\n.lines__table th {\r\n  text-align: start;\r\n  font-size: 0.85rem;\r\n  font-weight: 600;\r\n  color: var(--ink-2);\r\n  padding: 0.3rem 0.4rem;\r\n  border-bottom: 1px solid var(--line);\r\n}\r\n\r\n.lines__table td {\r\n  padding: 0.35rem 0.4rem;\r\n  border-bottom: 1px solid var(--line-soft);\r\n  vertical-align: top;\r\n}\r\n\r\n.lines__table--fixed th[scope='row'] {\r\n  font-weight: 600;\r\n  font-size: 0.92rem;\r\n  color: var(--ink);\r\n  border-bottom: 1px solid var(--line-soft);\r\n  vertical-align: middle;\r\n  white-space: nowrap;\r\n  width: 30%;\r\n}\r\n\r\n.lines__index {\r\n  width: 2.2rem;\r\n  color: var(--muted);\r\n  text-align: center !important;\r\n  vertical-align: middle !important;\r\n}\r\n\r\n.col--sm {\r\n  width: 110px;\r\n}\r\n\r\n.col--lg {\r\n  width: 45%;\r\n}\r\n\r\n.lines__value {\r\n  display: block;\r\n  padding: 0.3rem 0;\r\n  white-space: pre-wrap;\r\n}\r\n\r\n.lines__files {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  align-items: center;\r\n  gap: 0.35rem;\r\n  min-width: 140px;\r\n}\r\n\r\n.lines__remove {\r\n  width: 44px;\r\n  vertical-align: middle !important;\r\n}\r\n\r\n.lines__empty {\r\n  color: var(--muted);\r\n  font-size: 0.92rem;\r\n  padding: 0.3rem 0;\r\n}\r\n\r\n.lines__table tr.is-missing-file td {\r\n  background: #fff8f8;\r\n}\r\n\r\n.chips {\r\n  list-style: none;\r\n  margin: 0;\r\n  padding: 0;\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 0.35rem;\r\n}\r\n\r\n.card > .chips {\r\n  margin-top: 0.6rem;\r\n}\r\n\r\n.file-chip {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  border: 1px solid var(--line);\r\n  border-radius: 999px;\r\n  background: #f8f9fb;\r\n  max-width: 240px;\r\n}\r\n\r\n.file-chip__open {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 0.3rem;\r\n  border: 0;\r\n  background: transparent;\r\n  padding: 0.2rem 0.6rem;\r\n  font-size: 0.82rem;\r\n  color: var(--ink);\r\n  cursor: pointer;\r\n  min-width: 0;\r\n  min-height: 30px;\r\n}\r\n\r\n.file-chip__open span {\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n}\r\n\r\n.file-chip__open:hover {\r\n  color: var(--brand);\r\n  text-decoration: underline;\r\n}\r\n\r\n.file-chip__remove {\r\n  width: 28px;\r\n  height: 28px;\r\n  margin-inline-end: 2px;\r\n}\r\n\r\n.gallery {\r\n  list-style: none;\r\n  margin: 0.75rem 0 0;\r\n  padding: 0;\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));\r\n  gap: 0.6rem;\r\n}\r\n\r\n.gallery li {\r\n  position: relative;\r\n}\r\n\r\n.gallery__item {\r\n  display: flex;\r\n  flex-direction: column;\r\n  width: 100%;\r\n  padding: 0;\r\n  border: 1px solid var(--line);\r\n  border-radius: var(--radius-sm);\r\n  background: var(--surface);\r\n  overflow: hidden;\r\n  cursor: pointer;\r\n  text-align: start;\r\n}\r\n\r\n.gallery__item:hover {\r\n  border-color: var(--brand);\r\n}\r\n\r\n.gallery__thumb,\r\n.archive__thumb {\r\n  display: grid;\r\n  place-items: center;\r\n  aspect-ratio: 4 / 3;\r\n  background: #eef0f3;\r\n  color: var(--muted);\r\n  overflow: hidden;\r\n}\r\n\r\n.gallery__thumb img,\r\n.archive__thumb img {\r\n  width: 100%;\r\n  height: 100%;\r\n  object-fit: cover;\r\n}\r\n\r\n.gallery__name {\r\n  padding: 0.3rem 0.5rem;\r\n  font-size: 0.8rem;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n}\r\n\r\n.gallery__remove {\r\n  position: absolute;\r\n  top: 4px;\r\n  inset-inline-end: 4px;\r\n  background: rgba(255, 255, 255, 0.92);\r\n  width: 32px;\r\n  height: 32px;\r\n}\r\n\r\n.preview {\r\n  display: grid;\r\n  place-items: center;\r\n  min-height: 240px;\r\n  background: #111;\r\n  border-radius: var(--radius-sm);\r\n  margin-bottom: 0.6rem;\r\n}\r\n\r\n.preview img {\r\n  max-width: 100%;\r\n  max-height: 70vh;\r\n  object-fit: contain;\r\n}\r\n\r\n.notes {\r\n  list-style: none;\r\n  margin: 0;\r\n  padding: 0;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.5rem;\r\n}\r\n\r\n.notes li {\r\n  padding: 0.6rem 0.8rem;\r\n  border-inline-start: 3px solid var(--brand);\r\n  background: #fafafb;\r\n  border-radius: var(--radius-sm);\r\n}\r\n\r\n.notes p {\r\n  white-space: pre-wrap;\r\n}\r\n\r\n.notes footer {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  font-size: 0.82rem;\r\n  color: var(--muted);\r\n  margin-top: 0.25rem;\r\n}\r\n\r\n.note-form {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: flex-start;\r\n  gap: 0.5rem;\r\n  margin-top: 0.9rem;\r\n}\r\n\r\n.note-form .field {\r\n  width: 100%;\r\n}\r\n\r\n.comment-groups {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 1rem;\r\n}\r\n\r\n.comment-group__head {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.4rem;\r\n  font-size: 0.82rem;\r\n  font-weight: 600;\r\n  color: var(--ink-2);\r\n  margin-bottom: 0.5rem;\r\n}\r\n\r\n.comment-thread {\r\n  list-style: none;\r\n  margin: 0;\r\n  padding: 0;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.6rem;\r\n}\r\n\r\n.comment-message {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  gap: 0.55rem;\r\n  padding: 0.6rem 0.7rem;\r\n  background: #fafafb;\r\n  border: 1px solid var(--line-soft);\r\n  border-radius: var(--radius-sm);\r\n}\r\n\r\n.comment-message__avatar {\r\n  flex-shrink: 0;\r\n  display: grid;\r\n  place-items: center;\r\n  width: 24px;\r\n  height: 24px;\r\n  border-radius: 999px;\r\n  background: var(--brand-soft);\r\n  color: var(--brand);\r\n  font-size: 0.72rem;\r\n  font-weight: 700;\r\n}\r\n\r\n.comment-message__body {\r\n  flex: 1 1 auto;\r\n  min-width: 0;\r\n}\r\n\r\n.comment-message__head {\r\n  display: flex;\r\n  align-items: baseline;\r\n  gap: 0.4rem;\r\n  font-size: 0.85rem;\r\n}\r\n\r\n.comment-message__head time {\r\n  font-size: 0.76rem;\r\n  color: var(--muted);\r\n}\r\n\r\n.comment-message p {\r\n  margin: 0.15rem 0 0;\r\n  font-size: 0.86rem;\r\n  white-space: pre-wrap;\r\n}\r\n\r\n.checklist,\r\n.audit,\r\n.timeline {\r\n  list-style: none;\r\n  margin: 0;\r\n  padding: 0;\r\n}\r\n\r\n.checklist li {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.5rem;\r\n  padding: 0.3rem 0;\r\n  font-size: 0.92rem;\r\n}\r\n\r\n.checklist .is-done {\r\n  color: var(--complete);\r\n}\r\n\r\n.checklist .is-todo {\r\n  color: var(--missing);\r\n  font-weight: 500;\r\n}\r\n\r\n.timeline li {\r\n  position: relative;\r\n  display: flex;\r\n  flex-direction: column;\r\n  padding-inline-start: 1.3rem;\r\n  padding-bottom: 0.8rem;\r\n  border-inline-start: 2px solid var(--line);\r\n  margin-inline-start: 0.4rem;\r\n}\r\n\r\n.timeline li:last-child {\r\n  border-inline-start-color: transparent;\r\n  padding-bottom: 0.2rem;\r\n}\r\n\r\n.timeline li::before {\r\n  content: '';\r\n  position: absolute;\r\n  inset-inline-start: -7px;\r\n  top: 0.35rem;\r\n  width: 12px;\r\n  height: 12px;\r\n  border-radius: 50%;\r\n  background: var(--surface);\r\n  border: 2px solid var(--line);\r\n}\r\n\r\n.timeline li.is-done::before {\r\n  background: var(--complete);\r\n  border-color: var(--complete);\r\n}\r\n\r\n.timeline strong {\r\n  font-size: 0.92rem;\r\n}\r\n\r\n.timeline span,\r\n.timeline small {\r\n  font-size: 0.85rem;\r\n  color: var(--ink-2);\r\n}\r\n\r\n.timeline small {\r\n  color: var(--muted);\r\n}\r\n\r\n.audit {\r\n  max-height: 360px;\r\n  overflow-y: auto;\r\n}\r\n\r\n.audit li {\r\n  display: flex;\r\n  flex-direction: column;\r\n  padding: 0.4rem 0;\r\n  border-bottom: 1px solid var(--line-soft);\r\n  font-size: 0.85rem;\r\n}\r\n\r\n.audit li:last-child {\r\n  border-bottom: 0;\r\n}\r\n\r\n.audit span {\r\n  color: var(--muted);\r\n}\r\n\r\n.audit q {\r\n  color: var(--ink-2);\r\n  font-style: italic;\r\n}\r\n\r\n.back-link {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 0.3rem;\r\n  font-weight: 600;\r\n  text-decoration: none;\r\n}\r\n\r\n.savebar {\r\n  position: fixed;\r\n  bottom: 1rem;\r\n  left: 50%;\r\n  transform: translateX(-50%);\r\n  z-index: 40;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 1rem;\r\n  padding: 0.5rem 0.6rem 0.5rem 0.6rem;\r\n  padding-inline-start: 1.1rem;\r\n  background: var(--ink);\r\n  color: #fff;\r\n  border-radius: 999px;\r\n  box-shadow: var(--shadow-lg);\r\n  font-weight: 500;\r\n}\r\n\r\n.savebar .btn--primary {\r\n  border-radius: 999px;\r\n}\r\n\r\n.bulk-bar {\r\n  position: fixed;\r\n  bottom: 1rem;\r\n  left: 50%;\r\n  transform: translateX(-50%);\r\n  z-index: 40;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.25rem;\r\n  padding: 0.5rem;\r\n  background: var(--surface);\r\n  border: 1px solid var(--line);\r\n  border-radius: var(--radius);\r\n  box-shadow: var(--shadow-lg);\r\n}\r\n\r\n.bulk-bar__count {\r\n  padding: 0 0.5rem;\r\n  font-size: 0.85rem;\r\n  font-weight: 500;\r\n  color: var(--ink);\r\n  white-space: nowrap;\r\n}\r\n\r\n.bulk-bar__separator {\r\n  width: 1px;\r\n  height: 16px;\r\n  background: var(--line);\r\n  flex-shrink: 0;\r\n}\r\n\r\n.bulk-bar .btn {\r\n  min-height: 32px;\r\n  padding: 0.35rem 0.75rem;\r\n  background: transparent;\r\n  border-color: transparent;\r\n  color: var(--ink);\r\n  font-weight: 600;\r\n  font-size: 0.875rem;\r\n}\r\n\r\n.bulk-bar .btn:hover:not(:disabled) {\r\n  background: var(--bg);\r\n  border-color: transparent;\r\n}\r\n\r\n/* ---------- Alerts ---------- */\r\n\r\n.alert {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  gap: 0.6rem;\r\n  padding: 0.75rem 1rem;\r\n  border-radius: var(--radius-sm);\r\n  border: 1px solid;\r\n}\r\n\r\n.alert p {\r\n  white-space: pre-wrap;\r\n  margin-top: 0.2rem;\r\n}\r\n\r\n.alert .icon {\r\n  margin-top: 0.2rem;\r\n}\r\n\r\n.alert--error {\r\n  background: var(--missing-bg);\r\n  border-color: #fca5a5;\r\n  color: var(--missing);\r\n}\r\n\r\n.alert--warning {\r\n  background: var(--draft-bg);\r\n  border-color: #fcd34d;\r\n  color: #78350f;\r\n}\r\n\r\n.alert--info {\r\n  background: var(--created-bg);\r\n  border-color: #93c5fd;\r\n  color: var(--created);\r\n}\r\n\r\n.alert--success {\r\n  background: var(--complete-bg);\r\n  border-color: #86efac;\r\n  color: var(--complete);\r\n}\r\n\r\n/* ---------- Archive / summaries / settings ---------- */\r\n\r\n.archive {\r\n  list-style: none;\r\n  margin: 0;\r\n  padding: 0;\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));\r\n  gap: 0.6rem;\r\n}\r\n\r\n.archive__item {\r\n  display: grid;\r\n  grid-template-columns: 72px 1fr auto;\r\n  align-items: center;\r\n  gap: 0.7rem;\r\n  width: 100%;\r\n  padding: 0.45rem;\r\n  border: 1px solid var(--line);\r\n  border-radius: var(--radius-sm);\r\n  background: var(--surface);\r\n  text-align: start;\r\n  cursor: pointer;\r\n  color: var(--ink-2);\r\n}\r\n\r\n.archive__item:hover {\r\n  border-color: var(--brand);\r\n}\r\n\r\n.archive__thumb {\r\n  width: 72px;\r\n  border-radius: 4px;\r\n}\r\n\r\n.archive__meta {\r\n  display: flex;\r\n  flex-direction: column;\r\n  min-width: 0;\r\n}\r\n\r\n.archive__meta strong {\r\n  color: var(--ink);\r\n  font-size: 0.9rem;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n}\r\n\r\n.archive__meta small {\r\n  color: var(--muted);\r\n}\r\n\r\n.archive__row {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.3rem;\r\n}\r\n\r\n.summary-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(420px, 1fr));\r\n  gap: 1rem;\r\n}\r\n\r\n.roles-cell--yes {\r\n  color: var(--complete);\r\n}\r\n\r\n.roles-cell--conditional {\r\n  color: var(--draft);\r\n}\r\n\r\n.roles-cell--no {\r\n  color: var(--muted);\r\n}\r\n\r\n.catalog {\r\n  list-style: none;\r\n  margin: 0.8rem 0 0;\r\n  padding: 0;\r\n}\r\n\r\n.catalog li {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 0.4rem;\r\n  padding: 0.3rem 0;\r\n  border-bottom: 1px solid var(--line-soft);\r\n}\r\n\r\n.catalog__label {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 0.5rem;\r\n  font-weight: 500;\r\n}\r\n\r\n.catalog__actions {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 0.1rem;\r\n}\r\n\r\n/* ---------- Feedback ---------- */\r\n\r\n.spinner {\r\n  display: inline-block;\r\n  width: 26px;\r\n  height: 26px;\r\n  border: 3px solid var(--line);\r\n  border-top-color: var(--brand);\r\n  border-radius: 50%;\r\n  animation: spin 0.8s linear infinite;\r\n}\r\n\r\n.spinner--inline {\r\n  width: 16px;\r\n  height: 16px;\r\n  border-width: 2px;\r\n  border-color: currentColor;\r\n  border-top-color: transparent;\r\n}\r\n\r\n@keyframes spin {\r\n  to {\r\n    transform: rotate(360deg);\r\n  }\r\n}\r\n\r\n.loading {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 0.7rem;\r\n  padding: 3rem 1rem;\r\n  color: var(--muted);\r\n}\r\n\r\n.empty {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  gap: 0.6rem;\r\n  padding: 2.5rem 1rem;\r\n  text-align: center;\r\n  color: var(--muted);\r\n}\r\n\r\n.empty__title {\r\n  font-weight: 600;\r\n  color: var(--ink-2);\r\n}\r\n\r\n.empty--error {\r\n  color: var(--missing);\r\n}\r\n\r\n.toasts {\r\n  position: fixed;\r\n  top: 70px;\r\n  inset-inline-start: 50%;\r\n  transform: translateX(50%);\r\n  z-index: 60;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.5rem;\r\n  width: min(480px, calc(100vw - 2rem));\r\n}\r\n\r\n.toast {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  gap: 0.6rem;\r\n  padding: 0.7rem 0.6rem 0.7rem 0.9rem;\r\n  border-radius: var(--radius-sm);\r\n  background: var(--surface);\r\n  border: 1px solid var(--line);\r\n  border-inline-start: 4px solid var(--complete);\r\n  box-shadow: var(--shadow-lg);\r\n  animation: toast-in 180ms ease-out;\r\n}\r\n\r\n.toast .icon {\r\n  margin-top: 0.2rem;\r\n}\r\n\r\n.toast--success .icon {\r\n  color: var(--complete);\r\n}\r\n\r\n.toast--error {\r\n  border-inline-start-color: var(--missing);\r\n}\r\n\r\n.toast--error .icon {\r\n  color: var(--missing);\r\n}\r\n\r\n.toast--info {\r\n  border-inline-start-color: var(--created);\r\n}\r\n\r\n.toast--info .icon {\r\n  color: var(--created);\r\n}\r\n\r\n.toast__body {\r\n  flex: 1;\r\n}\r\n\r\n.toast__body ul {\r\n  margin: 0.3rem 0 0;\r\n  padding-inline-start: 1.1rem;\r\n  font-size: 0.88rem;\r\n  color: var(--ink-2);\r\n}\r\n\r\n.toast .icon-button {\r\n  width: 30px;\r\n  height: 30px;\r\n}\r\n\r\n@keyframes toast-in {\r\n  from {\r\n    opacity: 0;\r\n    transform: translateY(-6px);\r\n  }\r\n}\r\n\r\n/* ---------- Bell ---------- */\r\n\r\n.bell {\r\n  position: relative;\r\n}\r\n\r\n.bell__count {\r\n  position: absolute;\r\n  top: 2px;\r\n  inset-inline-end: 0;\r\n  min-width: 19px;\r\n  height: 19px;\r\n  padding: 0 5px;\r\n  border-radius: 999px;\r\n  background: #fbbf24;\r\n  color: #111;\r\n  font-size: 0.72rem;\r\n  font-weight: 700;\r\n  line-height: 19px;\r\n  text-align: center;\r\n}\r\n\r\n.bell__panel {\r\n  position: absolute;\r\n  top: calc(100% + 8px);\r\n  inset-inline-end: 0;\r\n  width: min(360px, calc(100vw - 1.5rem));\r\n  max-height: 70vh;\r\n  overflow-y: auto;\r\n  background: var(--surface);\r\n  color: var(--ink);\r\n  border: 1px solid var(--line);\r\n  border-radius: var(--radius);\r\n  box-shadow: var(--shadow-lg);\r\n}\r\n\r\n.bell__panel header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 0.6rem 0.8rem;\r\n  border-bottom: 1px solid var(--line-soft);\r\n}\r\n\r\n.bell__panel ul {\r\n  list-style: none;\r\n  margin: 0;\r\n  padding: 0;\r\n}\r\n\r\n.bell__panel li button {\r\n  display: flex;\r\n  gap: 0.6rem;\r\n  width: 100%;\r\n  padding: 0.6rem 0.8rem;\r\n  border: 0;\r\n  border-bottom: 1px solid var(--line-soft);\r\n  background: var(--surface);\r\n  text-align: start;\r\n  cursor: pointer;\r\n  color: var(--ink-2);\r\n}\r\n\r\n.bell__panel li button:hover {\r\n  background: var(--secondary, #f7f8fa);\r\n}\r\n\r\n.bell__panel li button.is-unread {\r\n  background: #fff9f0;\r\n  color: var(--ink);\r\n}\r\n\r\n.bell__panel li button .icon {\r\n  color: var(--missing);\r\n  margin-top: 0.2rem;\r\n}\r\n\r\n.bell__panel li span {\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.bell__panel small {\r\n  color: var(--muted);\r\n}\r\n\r\n.bell__empty {\r\n  padding: 1.5rem;\r\n  text-align: center;\r\n  color: var(--muted);\r\n}\r\n\r\n.bell__footer {\r\n  padding: 0.5rem 0.8rem;\r\n  text-align: center;\r\n}\r\n\r\n/* ---------- Modal ---------- */\r\n\r\n.modal-backdrop {\r\n  position: fixed;\r\n  inset: 0;\r\n  z-index: 50;\r\n  display: grid;\r\n  place-items: center;\r\n  padding: 1rem;\r\n  background: rgba(17, 24, 39, 0.5);\r\n}\r\n\r\n.modal {\r\n  display: flex;\r\n  flex-direction: column;\r\n  width: min(520px, 100%);\r\n  max-height: calc(100vh - 2rem);\r\n  background: var(--surface);\r\n  border-radius: var(--radius);\r\n  box-shadow: var(--shadow-lg);\r\n}\r\n\r\n.modal:focus {\r\n  outline: none;\r\n}\r\n\r\n.modal--wide {\r\n  width: min(820px, 100%);\r\n}\r\n\r\n.modal__header {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 1rem;\r\n  padding: 0.9rem 1.1rem;\r\n  border-bottom: 1px solid var(--line-soft);\r\n}\r\n\r\n.modal__header h2 {\r\n  font-size: 1.1rem;\r\n}\r\n\r\n.modal__body {\r\n  padding: 1.1rem;\r\n  overflow-y: auto;\r\n}\r\n\r\n.modal__footer {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  flex-wrap: wrap;\r\n  gap: 0.5rem;\r\n  padding: 0.8rem 1.1rem;\r\n  border-top: 1px solid var(--line-soft);\r\n}\r\n\r\n.side-sheet-backdrop {\r\n  position: fixed;\r\n  inset: 0;\r\n  z-index: 50;\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  background: rgba(17, 24, 39, 0.5);\r\n}\r\n\r\n.side-sheet {\r\n  display: flex;\r\n  flex-direction: column;\r\n  width: min(420px, 100%);\r\n  height: 100%;\r\n  background: var(--surface);\r\n  box-shadow: var(--shadow-lg);\r\n  animation: side-sheet-in 180ms ease-out;\r\n}\r\n\r\n.side-sheet:focus {\r\n  outline: none;\r\n}\r\n\r\n.side-sheet .modal__body {\r\n  flex: 1;\r\n}\r\n\r\n@keyframes side-sheet-in {\r\n  from {\r\n    transform: translateX(var(--side-sheet-offset, 100%));\r\n  }\r\n  to {\r\n    transform: translateX(0);\r\n  }\r\n}\r\n\r\n[dir='rtl'] .side-sheet {\r\n  --side-sheet-offset: -100%;\r\n}\r\n\r\n.system-page {\r\n  min-height: 100vh;\r\n  display: grid;\r\n  place-items: center;\r\n  padding: 1.5rem;\r\n  background: var(--bg);\r\n}\r\n\r\n.system-page__card {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  gap: 0.6rem;\r\n  max-width: 420px;\r\n  padding: 2.5rem 2rem;\r\n  text-align: center;\r\n  background: var(--surface);\r\n  border: 1px solid var(--line-soft);\r\n  border-radius: var(--radius);\r\n  box-shadow: var(--shadow);\r\n}\r\n\r\n.system-page__icon {\r\n  display: grid;\r\n  place-items: center;\r\n  width: 56px;\r\n  height: 56px;\r\n  margin-top: 0.4rem;\r\n  border-radius: 999px;\r\n  background: var(--brand-soft);\r\n  color: var(--brand);\r\n}\r\n\r\n.system-page__code {\r\n  font-size: 0.85rem;\r\n  font-weight: 700;\r\n  letter-spacing: 0.05em;\r\n  color: var(--muted);\r\n}\r\n\r\n.system-page__actions {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  justify-content: center;\r\n  gap: 0.6rem;\r\n  margin-top: 0.4rem;\r\n}\r\n\r\n.system-page__footer {\r\n  margin-top: 0.8rem;\r\n  padding-top: 0.8rem;\r\n  border-top: 1px solid var(--line-soft);\r\n  width: 100%;\r\n  font-size: 0.85rem;\r\n  color: var(--muted);\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  justify-content: center;\r\n  align-items: center;\r\n  gap: 0.4rem;\r\n}\r\n\r\n.alert-dialog__header {\r\n  display: flex;\r\n  gap: 1rem;\r\n  align-items: flex-start;\r\n  margin-bottom: 1.1rem;\r\n}\r\n\r\n.alert-dialog__icon {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  flex-shrink: 0;\r\n  width: 40px;\r\n  height: 40px;\r\n  border-radius: 999px;\r\n}\r\n\r\n.alert-dialog__icon--danger {\r\n  background: var(--missing-bg, #fee2e2);\r\n  color: var(--missing, #991b1b);\r\n}\r\n\r\n.alert-dialog__header-text h2 {\r\n  font-size: 1.1rem;\r\n  margin: 0 0 0.3rem;\r\n}\r\n\r\n.alert-dialog__sections {\r\n  margin-bottom: 1.1rem;\r\n  padding-bottom: 1.1rem;\r\n  border-bottom: 1px solid var(--line-soft);\r\n}\r\n\r\n.alert-dialog__sections .field__label {\r\n  margin-bottom: 0.15rem;\r\n}\r\n\r\n.alert-dialog__checkbox-grid {\r\n  display: grid;\r\n  grid-template-columns: 1fr 1fr;\r\n  gap: 0.5rem 1rem;\r\n  margin-top: 0.6rem;\r\n}\r\n\r\n/* ---------- Responsive ---------- */\r\n\r\n@media (max-width: 1100px) {\r\n  .report__layout {\r\n    grid-template-columns: minmax(0, 1fr);\r\n  }\r\n\r\n  .report__aside {\r\n    position: static;\r\n  }\r\n}\r\n\r\n@media (max-width: 720px) {\r\n  body {\r\n    font-size: 15px;\r\n  }\r\n\r\n  .shell__user-info {\r\n    display: none;\r\n  }\r\n\r\n  .form-grid {\r\n    grid-template-columns: minmax(0, 1fr);\r\n  }\r\n\r\n  .summary-grid {\r\n    grid-template-columns: minmax(0, 1fr);\r\n  }\r\n\r\n  .search input {\r\n    min-width: 0;\r\n    width: 100%;\r\n  }\r\n\r\n  .card__actions {\r\n    width: 100%;\r\n  }\r\n\r\n  .search {\r\n    flex: 1;\r\n  }\r\n\r\n  .savebar {\r\n    left: 1rem;\r\n    right: 1rem;\r\n    transform: none;\r\n    justify-content: space-between;\r\n  }\r\n}\r\n\r\n@media (max-width: 560px) {\r\n  /* Line tables collapse into stacked cards */\r\n  .lines__table thead {\r\n    display: none;\r\n  }\r\n\r\n  .lines__table,\r\n  .lines__table tbody,\r\n  .lines__table tr,\r\n  .lines__table td,\r\n  .lines__table th[scope='row'] {\r\n    display: block;\r\n    width: 100%;\r\n  }\r\n\r\n  .lines__table tr {\r\n    position: relative;\r\n    padding: 0.5rem 0;\r\n    border-bottom: 1px solid var(--line);\r\n  }\r\n\r\n  .lines__table td {\r\n    border: 0;\r\n    padding: 0.2rem 0;\r\n  }\r\n\r\n  .lines__table td[data-label]::before {\r\n    content: attr(data-label);\r\n    display: block;\r\n    font-size: 0.8rem;\r\n    font-weight: 600;\r\n    color: var(--muted);\r\n  }\r\n\r\n  .lines__index {\r\n    display: none !important;\r\n  }\r\n\r\n  .lines__remove {\r\n    position: absolute;\r\n    top: 0.3rem;\r\n    inset-inline-end: 0;\r\n    width: auto !important;\r\n  }\r\n}\r\n\r\n@media (prefers-reduced-motion: reduce) {\r\n  *,\r\n  *::before,\r\n  *::after {\r\n    animation-duration: 0.01ms !important;\r\n    transition-duration: 0.01ms !important;\r\n  }\r\n}\r\n\r\n/* ---------- Skeleton (loading placeholders) ---------- */\r\n\r\n.skeleton {\r\n  display: block;\r\n  background: var(--secondary, #f3f4f6);\r\n  border-radius: var(--radius-sm, 6px);\r\n  position: relative;\r\n  overflow: hidden;\r\n}\r\n\r\n.skeleton--circle {\r\n  border-radius: 999px;\r\n}\r\n\r\n.skeleton::after {\r\n  content: '';\r\n  position: absolute;\r\n  inset: 0;\r\n  transform: translateX(-100%);\r\n  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.6), transparent);\r\n  animation: skeleton-shimmer 1.6s ease-in-out infinite;\r\n}\r\n\r\n@keyframes skeleton-shimmer {\r\n  100% {\r\n    transform: translateX(100%);\r\n  }\r\n}\r\n\r\n.dashboard-skeleton__greeting {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.5rem;\r\n}\r\n\r\n.dashboard-skeleton__stats {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(130px, 1fr));\r\n  gap: 0.6rem;\r\n}\r\n\r\n.dashboard-skeleton__stat {\r\n  padding: 0.75rem 0.9rem;\r\n  border-radius: var(--radius);\r\n  border: 1px solid var(--line-soft);\r\n  border-inline-start: 4px solid var(--line-soft);\r\n  background: var(--surface);\r\n  box-shadow: var(--shadow);\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.5rem;\r\n}\r\n\r\n.dashboard-skeleton__card {\r\n  padding: 1rem 1.1rem;\r\n  border-radius: var(--radius);\r\n  border: 1px solid var(--line-soft);\r\n  background: var(--surface);\r\n  box-shadow: var(--shadow);\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.75rem;\r\n}\r\n\r\n.dashboard-skeleton__card-head {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.6rem;\r\n}\r\n\r\n.dashboard-skeleton__card-lines {\r\n  display: flex;\r\n  flex: 1 1 auto;\r\n  flex-direction: column;\r\n  gap: 0.4rem;\r\n}\r\n\r\n/* ---------- Review panel (sheet) ---------- */\r\n\r\n.sheet-backdrop {\r\n  position: fixed;\r\n  inset: 0;\r\n  z-index: 1300;\r\n  background: rgba(17, 24, 39, 0.5);\r\n}\r\n\r\n.sheet {\r\n  position: fixed;\r\n  top: 0;\r\n  bottom: 0;\r\n  inset-inline-end: 0;\r\n  width: min(480px, 100%);\r\n  display: flex;\r\n  flex-direction: column;\r\n  background: var(--surface);\r\n  box-shadow: var(--shadow-lg);\r\n  border-inline-start: 1px solid var(--line-soft);\r\n}\r\n\r\n.sheet__loading {\r\n  flex: 1;\r\n  display: grid;\r\n  place-items: center;\r\n  padding: 2rem;\r\n}\r\n\r\n.sheet__header {\r\n  flex-shrink: 0;\r\n  padding: 1.1rem 1.3rem;\r\n  border-bottom: 1px solid var(--line-soft);\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.85rem;\r\n}\r\n\r\n.sheet__title-row {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 0.6rem;\r\n}\r\n\r\n.sheet__title-row h2,\r\n.sheet__title-row h3 {\r\n  font-size: 1.05rem;\r\n  margin: 0;\r\n}\r\n\r\n.sheet__report-head {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.4rem;\r\n}\r\n\r\n.sheet__meta-row {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.6rem;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.sheet__code {\r\n  font-family: var(--font-mono, monospace);\r\n  font-size: 0.8rem;\r\n  color: var(--ink-2);\r\n}\r\n\r\n.sheet__divider {\r\n  width: 1px;\r\n  height: 16px;\r\n  background: var(--line);\r\n}\r\n\r\n.sheet__engineer {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.4rem;\r\n  font-size: 0.88rem;\r\n  color: var(--ink-2);\r\n}\r\n\r\n.sheet__avatar {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 20px;\r\n  height: 20px;\r\n  border-radius: 999px;\r\n  background: var(--brand-soft);\r\n  color: var(--brand);\r\n  font-size: 0.65rem;\r\n  font-weight: 700;\r\n}\r\n\r\n.sheet__body {\r\n  flex: 1;\r\n  overflow-y: auto;\r\n  padding: 1.1rem 1.3rem;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 1.3rem;\r\n}\r\n\r\n.sheet__sections-head {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  font-size: 0.88rem;\r\n  font-weight: 600;\r\n  margin-bottom: 0.4rem;\r\n}\r\n\r\n.sheet__footer {\r\n  flex-shrink: 0;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.6rem;\r\n  padding: 0.9rem 1.3rem;\r\n  border-top: 1px solid var(--line-soft);\r\n}\r\n\r\n.sheet__footer p {\r\n  flex: 1;\r\n  margin: 0;\r\n}\r\n\r\n.review-panel__list {\r\n  list-style: none;\r\n  margin: 0;\r\n  padding: 0;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.1rem;\r\n}\r\n\r\n.review-panel__row {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.6rem;\r\n  padding: 0.45rem 0.4rem;\r\n  border-radius: var(--radius-sm);\r\n}\r\n\r\n.review-panel__row:hover {\r\n  background: var(--secondary, #fafbfc);\r\n}\r\n\r\n.review-panel__label {\r\n  flex: 1;\r\n  font-size: 0.88rem;\r\n}\r\n\r\n.review-panel__composer {\r\n  padding: 0.5rem 0.4rem 0.8rem;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.5rem;\r\n}\r\n\r\n.review-panel__decision {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.6rem;\r\n}\r\n\r\n.radio-card {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.85rem;\r\n  padding: 1rem;\r\n  border: 1px solid var(--line-soft);\r\n  border-radius: var(--radius);\r\n  background: var(--surface);\r\n  text-align: start;\r\n  cursor: pointer;\r\n}\r\n\r\n.radio-card.is-checked {\r\n  border: 2px solid var(--brand);\r\n  background: var(--brand-soft);\r\n  padding: 0.95rem;\r\n}\r\n\r\n.radio-card__radio {\r\n  flex-shrink: 0;\r\n  width: 16px;\r\n  height: 16px;\r\n  border: 1px solid var(--line);\r\n  border-radius: 999px;\r\n  background: var(--bg);\r\n}\r\n\r\n.radio-card.is-checked .radio-card__radio {\r\n  border: 5px solid var(--brand);\r\n  background: var(--surface);\r\n}\r\n\r\n.radio-card__icon {\r\n  flex-shrink: 0;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 32px;\r\n  height: 32px;\r\n  border-radius: var(--radius-sm);\r\n  background: var(--bg);\r\n}\r\n\r\n.radio-card__text {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.15rem;\r\n}\r\n\r\n.profile-summary {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  align-items: center;\r\n  gap: 1rem;\r\n}\r\n\r\n.profile-summary > div:first-of-type {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.3rem;\r\n}\r\n\r\n.profile-summary__meta {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 1.5rem;\r\n  margin-inline-start: auto;\r\n}\r\n\r\n.profile-summary__meta dt {\r\n  font-size: 0.8rem;\r\n  color: var(--muted);\r\n}\r\n\r\n.profile-summary__meta dd {\r\n  margin: 0;\r\n  font-weight: 600;\r\n}\r\n\r\n.radio-card-row {\r\n  display: flex;\r\n  gap: 0.75rem;\r\n}\r\n\r\n.radio-card-row .radio-card {\r\n  flex: 1;\r\n}\r\n\r\n/* ---------- Report lifecycle tracker ---------- */\r\n\r\n.lifecycle {\r\n  background: var(--surface);\r\n  border: 1px solid var(--line-soft);\r\n  border-radius: var(--radius);\r\n  box-shadow: var(--shadow);\r\n  padding: 1.25rem 1.5rem 1rem;\r\n}\r\n\r\n.lifecycle__steps {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  list-style: none;\r\n  margin: 0;\r\n  padding: 0;\r\n}\r\n\r\n.lifecycle__step {\r\n  display: flex;\r\n  flex: 1 1 0;\r\n  min-width: 0;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  position: relative;\r\n  text-align: center;\r\n  gap: 0.3rem;\r\n}\r\n\r\n.lifecycle__connector {\r\n  position: absolute;\r\n  top: 15px;\r\n  inset-inline-end: 50%;\r\n  width: 100%;\r\n  height: 2px;\r\n  background: var(--line-soft);\r\n}\r\n\r\n.lifecycle__step.is-reached .lifecycle__connector,\r\n.lifecycle__step.is-current .lifecycle__connector,\r\n.lifecycle__step.is-returned .lifecycle__connector {\r\n  background: var(--complete);\r\n}\r\n\r\n.lifecycle__step.is-returned .lifecycle__connector {\r\n  background: var(--missing);\r\n}\r\n\r\n.lifecycle__dot {\r\n  z-index: 1;\r\n  display: grid;\r\n  place-items: center;\r\n  width: 32px;\r\n  height: 32px;\r\n  border-radius: 999px;\r\n  background: var(--surface);\r\n  border: 2px solid var(--line);\r\n  color: var(--ink-2);\r\n  font-size: 0.85rem;\r\n  font-weight: 700;\r\n}\r\n\r\n.lifecycle__step.is-reached .lifecycle__dot {\r\n  background: var(--complete);\r\n  border-color: var(--complete);\r\n  color: #fff;\r\n}\r\n\r\n.lifecycle__step.is-current .lifecycle__dot {\r\n  background: var(--created-bg);\r\n  border-color: var(--created);\r\n  color: var(--created);\r\n}\r\n\r\n.lifecycle__step.is-returned .lifecycle__dot {\r\n  background: var(--missing);\r\n  border-color: var(--missing);\r\n  color: #fff;\r\n}\r\n\r\n.lifecycle__label {\r\n  font-size: 0.88rem;\r\n  font-weight: 600;\r\n  color: var(--ink);\r\n}\r\n\r\n.lifecycle__meta {\r\n  font-size: 0.78rem;\r\n  color: var(--ink-2);\r\n}\r\n\r\n.lifecycle__reason {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  gap: 0.4rem;\r\n  margin: 0.9rem 0 0;\r\n  padding: 0.6rem 0.8rem;\r\n  border-radius: var(--radius-sm);\r\n  background: var(--missing-bg);\r\n  color: var(--missing);\r\n  font-size: 0.85rem;\r\n}\r\n\r\n/* ---------- Collapsible section card ---------- */\r\n\r\n.collapsible-card {\r\n  padding: 0;\r\n  overflow: hidden;\r\n}\r\n\r\n.collapsible-card__header {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 0.5rem 1rem;\r\n  padding: 0.85rem 1.1rem;\r\n}\r\n\r\n.collapsible-card__toggle {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.6rem;\r\n  flex: 1 1 auto;\r\n  min-width: 0;\r\n  background: none;\r\n  border: none;\r\n  padding: 0;\r\n  cursor: pointer;\r\n  text-align: start;\r\n  color: inherit;\r\n  font: inherit;\r\n}\r\n\r\n.collapsible-card__chevron {\r\n  flex-shrink: 0;\r\n  color: var(--ink-2);\r\n  transition: transform 150ms ease;\r\n}\r\n\r\n.collapsible-card__chevron.is-collapsed {\r\n  transform: rotate(-90deg);\r\n}\r\n\r\n[dir='rtl'] .collapsible-card__chevron.is-collapsed {\r\n  transform: rotate(90deg);\r\n}\r\n\r\n.collapsible-card__icon {\r\n  display: grid;\r\n  place-items: center;\r\n  flex-shrink: 0;\r\n  width: 32px;\r\n  height: 32px;\r\n  border-radius: var(--radius-sm);\r\n  background: var(--secondary, #f3f4f6);\r\n  color: var(--ink-2);\r\n}\r\n\r\n.collapsible-card__title {\r\n  font-size: 1.08rem;\r\n  font-weight: 700;\r\n  color: var(--ink);\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n}\r\n\r\n.collapsible-card__end {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  align-items: center;\r\n  gap: 0.5rem;\r\n}\r\n\r\n.collapsible-card__body {\r\n  padding: 0 1.1rem 1.1rem;\r\n  border-top: 1px solid var(--line-soft);\r\n  padding-top: 1.1rem;\r\n}\r\n\r\n/* ---------- Approval card (dashboard) ---------- */\r\n\r\n.approval-card-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));\r\n  gap: 1rem;\r\n}\r\n\r\n.approval-card {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.7rem;\r\n  padding: 1rem;\r\n  background: var(--surface);\r\n  border: 1px solid var(--line-soft);\r\n  border-radius: var(--radius);\r\n  box-shadow: var(--shadow);\r\n}\r\n\r\n.approval-card__head {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  gap: 0.6rem;\r\n}\r\n\r\n.approval-card__avatar {\r\n  flex-shrink: 0;\r\n  display: grid;\r\n  place-items: center;\r\n  width: 32px;\r\n  height: 32px;\r\n  border-radius: 999px;\r\n  background: var(--brand-soft);\r\n  color: var(--brand);\r\n  font-size: 0.78rem;\r\n  font-weight: 700;\r\n}\r\n\r\n.approval-card__who {\r\n  flex: 1 1 auto;\r\n  min-width: 0;\r\n}\r\n\r\n.approval-card__name {\r\n  font-weight: 600;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n}\r\n\r\n.approval-card__time {\r\n  flex-shrink: 0;\r\n  white-space: nowrap;\r\n}\r\n\r\n.approval-card__meta {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 0.5rem;\r\n}\r\n\r\n.approval-card__kpis {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 0.5rem;\r\n}\r\n\r\n.kpi-chip {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 0.3rem;\r\n  padding: 0.25rem 0.55rem;\r\n  border-radius: var(--radius-sm);\r\n  background: var(--secondary, #f3f4f6);\r\n  color: var(--ink-2);\r\n  font-size: 0.8rem;\r\n}\r\n\r\n.kpi-chip strong {\r\n  color: var(--ink);\r\n  font-variant-numeric: tabular-nums;\r\n}\r\n\r\n.approval-card__actions {\r\n  display: flex;\r\n  gap: 0.5rem;\r\n  margin-top: auto;\r\n}\r\n\r\n.approval-card__actions .btn {\r\n  flex: 1 1 0;\r\n  justify-content: center;\r\n}\r\n\r\n/* ---------- Compliance card (report submission this week) ---------- */\r\n\r\n.compliance-card {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.5rem;\r\n}\r\n\r\n.compliance-card__row {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.75rem;\r\n}\r\n\r\n.compliance-card__site {\r\n  flex: 1 1 0;\r\n  min-width: 0;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n  font-weight: 500;\r\n}\r\n\r\n.compliance-card__row--head .compliance-card__site {\r\n  font-weight: 400;\r\n}\r\n\r\n.compliance-card__days {\r\n  display: flex;\r\n  gap: 0.4rem;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.compliance-day-label {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 32px;\r\n  overflow: hidden;\r\n  font-size: 0.72rem;\r\n  line-height: 1;\r\n  white-space: nowrap;\r\n  color: var(--ink-2);\r\n}\r\n\r\n.compliance-day {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 32px;\r\n  height: 32px;\r\n  border-radius: var(--radius-sm);\r\n  color: var(--ink-2);\r\n}\r\n\r\n.compliance-day--onTime {\r\n  background: var(--success-subtle, #ecfdf3);\r\n  color: var(--success, #027a48);\r\n}\r\n\r\n.compliance-day--late {\r\n  background: var(--warning-subtle, #fffaeb);\r\n  color: var(--warning-subtle-foreground, #b54708);\r\n}\r\n\r\n.compliance-day--missed {\r\n  background: var(--danger-subtle, #fef3f2);\r\n  color: var(--danger-subtle-foreground, #b42318);\r\n}\r\n\r\n.compliance-day--none {\r\n  background: var(--secondary, #f3f4f6);\r\n  color: var(--ink-2);\r\n}\r\n\r\n.compliance-day--upcoming {\r\n  border: 1px dashed var(--line);\r\n}\r\n\r\n.compliance-day--legend {\r\n  width: 14px;\r\n  height: 14px;\r\n  border-radius: 4px;\r\n}\r\n\r\n.compliance-card__rate {\r\n  flex-shrink: 0;\r\n  width: 44px;\r\n  text-align: end;\r\n  font-weight: 600;\r\n  font-variant-numeric: tabular-nums;\r\n}\r\n\r\n.compliance-card__legend {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  align-items: center;\r\n  gap: 1rem;\r\n  margin-top: 0.4rem;\r\n  padding-top: 0.6rem;\r\n  border-top: 1px solid var(--line-soft);\r\n  font-size: 0.78rem;\r\n  color: var(--ink-2);\r\n}\r\n\r\n.compliance-card__legend span {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 0.3rem;\r\n}\r\n\r\n/* ---------- Report status chart (report status by site) ---------- */\r\n\r\n.status-chart {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.75rem;\r\n}\r\n\r\n.status-chart__plot {\r\n  width: 100%;\r\n}\r\n\r\n.status-chart__legend {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 1rem;\r\n  font-size: 0.8rem;\r\n  color: var(--ink-2);\r\n}\r\n\r\n.status-chart__legend span {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 0.35rem;\r\n}\r\n\r\n.status-chart__swatch {\r\n  width: 10px;\r\n  height: 10px;\r\n  border-radius: 2px;\r\n}\r\n\r\n.chart-tooltip {\r\n  min-width: 160px;\r\n  padding: 0.5rem 0.65rem;\r\n  background: var(--surface);\r\n  border: 1px solid var(--line-soft);\r\n  border-radius: var(--radius-sm);\r\n  box-shadow: var(--shadow-lg);\r\n  font-size: 0.8rem;\r\n}\r\n\r\n.chart-tooltip__title {\r\n  margin: 0 0 0.35rem;\r\n  font-weight: 600;\r\n}\r\n\r\n.chart-tooltip__row {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.4rem;\r\n  padding: 0.1rem 0;\r\n}\r\n\r\n.chart-tooltip__row--total {\r\n  margin-top: 0.3rem;\r\n  padding-top: 0.3rem;\r\n  border-top: 1px solid var(--line-soft);\r\n}\r\n\r\n.chart-tooltip__dot {\r\n  width: 8px;\r\n  height: 8px;\r\n  border-radius: 2px;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.chart-tooltip__label {\r\n  flex: 1 1 auto;\r\n  color: var(--ink-2);\r\n}\r\n\r\n.export-split {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\r\n  gap: 1rem;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
